/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>cui-device-settings.component.ts</name>
///
/// <description>
/// A component that presents Device Configuration for Crestron Common UI
/// </description>
///
/// <author>Michael Martinez</author>
/// <created>12 Dec 2017</created>
///
/// </file>
/// ----------------------------------------------------------------------------------------
///
import { AuthorizationService } from '../../authorization/shared/authorization.service';


import {Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef} from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/timeout';

import { Http, RequestOptions, Headers, Response } from '@angular/http';
import { AbstractControl, FormsModule, ReactiveFormsModule, FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';

import {hydUtilService} from "../../utils/hydUtils.service";
import {HydUser} from "../../models/user";

import {Accordion, AccordionTab, Dropdown, Message, MenuItem, SelectItem, CalendarModule} from 'primeng/primeng';

import {CUISingularSettingComponent} from '../cui-singular-setting/cui-singular-setting.component';

import {DevicePropertyType } from  '../../models/device-data-models/device-property-type.model';
import {DeviceControlEventModel } from  '../../models/device-data-models/device-control-event.model';
import {DeviceControlActionType } from  '../../models/device-data-models/device-control-action-type.model';
import {DeviceFormControlModel  } from  '../../models/device-data-models/device-form-control.model';
import {DeviceControlType } from  '../../models/device-data-models/device-control-type.model';
import {DeviceControlModel } from  '../../models/device-data-models/device-control.model';
import {DeviceCategoryModel } from  '../../models/device-data-models/device-category.model';
import {DeviceCategoryCollectionModel } from  '../../models/device-data-models/device-category-collection.model';
import {CUIFeatureInterface, CUICanDeativateInterface} from  '../../interfaces/cui-feature.interface';


import {ValidationService} from  '../../services/validation.service';
import {MediatorService} from '../../services/mediator.service';
import {MediatorEventLookup} from '../../services/mediator-event-lookup.service';

import {CUIGridColumn } from '../cui-grid/cui-grid-column';

import {TranslatedStringsService } from '../../services/language.service';
import * as moment from 'moment';
import { RouteDeactivationInfo } from '../../interfaces/cui-route-deactivation.interface';


import {
    App,
    Adapter,
    Addresses,
    AirMedia,
    AudioDevices,
    AudioVideoInputOutput,
    AutoUpdateMaster,
    Credentials,
    Background,
    Bluetooth,
    CustomBackground,
    Device,
    DeviceList,
    DevicesSearch,
    DeviceOperation,
    DeliveryStateEnum,
    DownstreamEdid,
    Ethernet,
    FusionSetup,
    FusionCloud,
    General,
    Hdmi,
    IPAddr,
    InputOutput,
    LicenseRegistry,
    Logo,
    MergeAction,
    OperationStateEnum,
    OperationEnum,
    Port,
    Scheduling,
    SIP,
    Settings as AVFSettings,
    Speedkey,
    Sntp,
    SystemVersions,
    SystemClock,
    RunTimeSettings,
    TimeOptions,
    USB,
    VideoDisplay,
    SFB,
    Preset,
    ConnectionDisplayOptions,
    ThirdPartyApplications,
    ZoomRoom,
    DeviceRequest,
    FWSIP,
    CloudSettings,
    FusionCloud2,
    DeviceSettingsStatus,
    ObjectComponent
} from'../../services/Crestron.HydrogenAPI.DeviceApi.service';



import {CUICommunicationServiceInterface} from '../../interfaces/cui-communication-service.interface';
import { DeviceModel, DeviceMetaDataInfoApiClient } from '../../services/Crestron.HydrogenAPI.DeviceMetaDataInfoClient';



declare let jQuery: any;
declare let Olympos: any;
declare let objectPath: any;
declare let CryptoJS: any;


@Component({
    selector: 'cui-device-settings',
    template: ''
})
export class CUIDeviceSettingsComponent implements CUIFeatureInterface {


    @Output() onSaveSettings = new EventEmitter();
    @Output() onRevertSettings = new EventEmitter();
    @Output() onNotification = new EventEmitter();
    @Output() onFormEvent = new EventEmitter();



    protected device: Device;
    protected loadViewModelSubscription: Subscription;
    protected loadDefaultViewModelSubscription: Subscription;
    protected loadModelTypesSubscription: Subscription;

    protected invalidFields: string;
    protected deviceUpdates: string[];

    protected modelTypes: any;
    protected modelDefault: string = "MERCURY";
    protected modelType: string = this.modelDefault;
    protected dirty: boolean = false;


    protected sourceSettings: Device;
    protected viewModel: any = null;
    protected viewModelDefault: any = null;
    protected displayDrivers: any = {};
    protected displayDriverID: string = "1D3A3D17-0F53-4f37-AF72-C5EEF9275477";
    protected settings: any = [];
    protected id: string = "";

    protected formSettings: FormGroup;
    protected saved: boolean = false;

    protected permissions: any;
    protected tabState = new Array<boolean>();


    protected changedNIC: boolean = false;//MM - If at least one NIC field changes, send all NIC fields
    protected changedVideoDisplay: boolean = false;
    protected changedBackground: boolean = false;//MM - If at least one Custom Background field changes, send all NIC fields
    protected changedAirMediaConnection: boolean = false;
    protected changedFusionCloud: boolean = false;//MM - Bug 147575 - Added check for Fusion Cloud



    protected lblName: string;
    protected lblPermissions: string;
    protected lblSaveChanges: string;
    protected lblRevert: string;
    protected lblSelectItemsGroupSettings: string;
    protected lblSelectAll: string;
    protected lblLastCommunicated: string;
    protected lblCancelButtonLabel: string;
    protected lblConfirmButtonLabel: string;
    protected lblSettingsConflictedConfirm: string;
    protected lblSettingsConflictedList: string;
    protected lblConfirmHeaderSettingsConflict: string;
    protected lblDevices: string;
    protected lblProceedConfirm: string;

    protected displayConflictConfirm: boolean = false;
    protected conflictedFields: string;

    protected zoomRoomConfirmDialog: boolean = false;
    protected lblzoomRoomConfirmDialogMessage: string;
    protected zoomRoomInitValue: boolean;
    protected zoomRoomConfDialogTitle: string;
    protected lblZoomRoomOK: string;
    protected lblZoomRoomCancel: string;

    protected lblOf: string;
    protected lblSettingsDeliveryCount: string;
    protected lblDeviceOnline: string;
    protected lblDeviceOffline: string;
    protected lblNoSettings: string;
    protected bNoSettings: boolean = true;
    protected lblDeviceModel: string;

    protected statusClass: string;
    protected statusText: string;

    protected touched: boolean = false;

    protected loaded: boolean = false;
    protected loading: boolean = false;
    protected allOperations: Array<DeviceOperation>;
    protected toggleAll: boolean = false;


    constructor(

        private communicationInterface: CUICommunicationServiceInterface,

        protected mediatorService: MediatorService,
        protected validationService: ValidationService,

        protected translationService: TranslatedStringsService,
        protected route: ActivatedRoute,
        protected http: Http


    ) {

    }
    //----------------------------------------------------------
    //Implementations of Interface
    //----------------------------------------------------------

    ngDoCheck() { };
    ngAfterContentInit() { };
    ngAfterContentChecked() { };
    ngAfterViewInit() { };
    ngAfterViewChecked() { };



    //----------------------------------------------------------
    //ngOnInit
    //----------------------------------------------------------
    ngOnInit() {

        this.formSettings = new FormGroup({});
        this.translate();




    }


    //----------------------------------------------------------
    //ngOnChanges
    //----------------------------------------------------------
    ngOnChanges(changes: any) {



    }

    //----------------------------------------------------------
    //ngOnDestroy
    //----------------------------------------------------------
    ngOnDestroy() {

        this.stopViewModelsSubscriptions();
        this.stopDefaultViewModelsSubscriptions();
        this.stopModelTypesSubscriptions();

    }


    //----------------------------------------------------------
    //stopViewModelsSubscriptions
    //----------------------------------------------------------
    protected stopViewModelsSubscriptions() {

        if (this.loadViewModelSubscription)
            this.loadViewModelSubscription.unsubscribe();


    }

    //----------------------------------------------------------
    //stopDefaultViewModelsSubscriptions
    //----------------------------------------------------------
    protected stopDefaultViewModelsSubscriptions() {

        if (this.loadDefaultViewModelSubscription)
            this.loadDefaultViewModelSubscription.unsubscribe();


    }

    //----------------------------------------------------------
    //stopModelTypesSubscriptions
    //----------------------------------------------------------
    protected stopModelTypesSubscriptions() {

        if (this.loadModelTypesSubscription)
            this.loadModelTypesSubscription.unsubscribe();




    }

    //-----------------------------------------------
    // start
    //-----------------------------------------------
    protected start() {

        this.loadDisplayDriverTable();


    }

    //-----------------------------------------------
    // getValueFromSetting
    //-----------------------------------------------
    protected getValueFromSetting(parent: any, settingID: string, visible: boolean, propertyType: DevicePropertyType,
        hardPath: string, softPath: string, defaultValue: any, controlType?: DeviceControlType) {

        let value: any;

        try {

            switch (propertyType) {
                case DevicePropertyType.GetValue:
                    value = this.resolveDeviceValue(parent, settingID, hardPath, softPath, defaultValue, controlType);
                    break;
                case DevicePropertyType.Apply:
                    if (this.device) {
                        value = true;
                    }

                    break;
            }
        }
        catch (e) {
            console.log("Error--> getValueFromSetting: " + settingID + " path: " + hardPath);
        }
        return value;

    }

    //-----------------------------------------------
    // buildViewModel
    //-----------------------------------------------
    protected buildViewModel(): any {

        let categories: DeviceCategoryCollectionModel = new DeviceCategoryCollectionModel();
        try {

            this.sourceSettings = null;
            if (this.device) {
                this.sourceSettings = this.device;
            }

            categories = <DeviceCategoryCollectionModel>this.viewModel;

            if (!this.sourceSettings) this.sourceSettings = new Device();


            if (this.sourceSettings && categories && categories.length > 0) {


                if (this.device) {
                    categories.action = this.device.action;
                    categories.id = this.device.id;
                }


                this.fillViewModel(categories);


            }


        }

        catch (e) {
            console.log("Error-->buildViewModel()");
        }
        return categories;

    }

    //----------------------------------------------------------
    //validateForm
    //----------------------------------------------------------
    protected validateForm(
        checkNIC1: boolean, checkNIC2: boolean,
        checkSIP: boolean,
        checkBluetooth: boolean,
        checkFusion: boolean,
        checkCallNotification: boolean,
        checkCustomBackground: boolean,
        checkAirMedia: boolean,
        checkAirMediaConnectionInfo: boolean,
        checkScheduling: boolean,
        checkCustomLogo: boolean,
        checkSfB: boolean,
        checkConnectionDispaly: boolean,
        checkZoomRoom: boolean,
        check3SeriesFusionCloud: boolean,
        checkPowerShceduling: boolean,
        checkAppspace: boolean,
    checkTouchscreenbackgrounds:boolean) {


        try {
            this.checkVideoDisplay();

            //For APPSPACE changes.
            if (checkPowerShceduling) {
                this.checkPowerShceduling();
            }

            if (checkAppspace) {
                this.checkAppspace();
            }

            if (checkTouchscreenbackgrounds)
            {
                this.checkTouchScreenCustomeBackgrounds()
            }

            //For CFA - Add condition to check Device Model.. CFA is only for MERCURY, AM-200, AM-300
            if (this.modelTypesForCFA()) {
                if (checkNIC1 || checkNIC2) {
                    this.checkEthernetForCFA(checkNIC1, checkNIC2);
                }
            }
            else {
                if (checkNIC1 || checkNIC2) {
                    this.checkEthernet(this.formSettings.controls);
                }
            }
            if (checkSIP) {
                this.checkSIP();
            }
            if (checkBluetooth) {
                this.checkBluetooth();
            }
            if (checkFusion) {
                this.checkFusion();
            }

            if (checkCallNotification) {
                this.checkCallNotification();
            }

            if (checkCustomLogo) {
                this.checkCustomLogo();
            }

            if (checkCustomBackground) {
                this.checkCustomBackgrounds();
            }

            if (checkAirMediaConnectionInfo) {
                let timer = Observable.timer();
                timer.timeout(1000);
                timer.subscribe(t => {
                    this.checkAirMediaConnectionInfo();
                });
            }

            if (checkScheduling) {
                let timer = Observable.timer();
                timer.timeout(1000);
                timer.subscribe(t => {
                    this.checkScheduling();
                });
            }

            if (checkSfB) {
                this.checkSFB();
            }

            if (checkConnectionDispaly) {
                this.checkAirMediaConnectionDisplay();
            }

            if (checkZoomRoom) {
                this.checkZoomRoomInit();
            }

            if (check3SeriesFusionCloud) {
                this.check3SeriesFusionCloudInit();
            }

            if (checkAirMedia) {

              //MM - Bug 146537 - Don't wait, just execute, to prevent validation from blinking..
              this.checkAirMedia();
              //let timer = Observable.timer();
              //timer.timeout(1000);
              //timer.subscribe(t => {
              //  this.checkAirMedia();
              //});
            }

            this.cleanFormValidation();


        }
        catch (e) {
            console.log("Error-->validateForm()");
        }

    }

    //----------------------------------------------------------
    //cleanFormValidation
    //----------------------------------------------------------
    protected cleanFormValidation() {

        let bFlag = true;
        let controls: any = this.formSettings.controls;
        for (var index in controls) {
            if (controls[index].model) {
                if (controls[index].model.apply && controls[index].model.inherited) {
                    controls[index].clearValidators();


                }
            }

        }

        return bFlag;
    }

    //----------------------------------------------------------
    //cleanEnableDisable
    //----------------------------------------------------------
    protected cleanEnableDisable() {


        if (this.formSettings) {
            let controls: any = this.formSettings.controls;
            for (var index in controls) {
                if (controls[index].model) {
                    let setting: any = controls[index].model;

                    if (this.isSettingDisabled(setting)) {
                        controls[index].disable();
                    }
                    else {
                        controls[index].enable();
                    }
                }

            }

        }

    }


    //----------------------------------------------------------
    //buildPage
    //----------------------------------------------------------
    protected buildPage() {

        try {
            //Bug 138830 - [Pre-Prod] Save Changes & Revert under Action menu of Group page always gets Enabled
            //this.mediatorService.Action(MediatorEventLookup.DetailFormChanged, this.translationService.translate("account-action"));
            this.toggleAll = false;
            this.dirty = false;

            this.loading = true;
            this.settings = this.buildViewModel();
            this.formSettings = this.toFormGroup(this.settings);


            this.validateForm(true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true,true,true);

            let timer = Observable.timer();
            timer.timeout(500);
            timer.subscribe(t => {
                this.cleanEnableDisable();
            });


            this.loading = false;
            this.loaded = true;




        }
        catch (e) {
            console.log("Error-->buildPage()");
        }
    }

    //----------------------------------------------------------
    //translate
    //----------------------------------------------------------
    protected translate() {


        this.lblDeviceModel = this.translationService.translate("device-modal");
        this.lblNoSettings = this.translationService.translate("no-settings");
        this.lblDeviceOnline = this.translationService.translate("device-status-online");
        this.lblDeviceOffline = this.translationService.translate("device-status-offline");
        this.lblName = this.translationService.translate("name");
        this.lblPermissions = this.translationService.translate("user-access");
        this.lblSelectItemsGroupSettings = this.translationService.translate("select-items-group-setting");

        this.lblSaveChanges = this.translationService.translate("form-save-changes");
        this.lblRevert = this.translationService.translate("form-revert");
        this.lblSelectAll = this.translationService.translate("select-all");
        this.lblLastCommunicated = this.translationService.translate("last-communicated");

        this.lblCancelButtonLabel = this.translationService.translate('cancel-button-label');
        this.lblConfirmButtonLabel = this.translationService.translate('confirm-button-label');
        this.lblSettingsConflictedConfirm = this.translationService.translate('settings-conflicted-confirm');
        this.lblProceedConfirm = this.translationService.translate('proceed-confirm');
        this.lblConfirmHeaderSettingsConflict = this.translationService.translate('settings-conflict-confirm-header');
        this.lblSettingsConflictedList = this.translationService.translate('settings-conflicted-list');
        this.lblDevices = this.translationService.translate('devices');
        this.lblOf = this.translationService.translate("of");
        this.lblSettingsDeliveryCount = this.translationService.translate("group-settings-delivery-count");



        this.zoomRoomConfDialogTitle = this.translationService.translate("zoomRoom-ConfirmDialog-Title");
        this.lblZoomRoomOK = this.translationService.translate("zoomRoom-Ok");
        this.lblZoomRoomCancel = this.translationService.translate("zoomRoom-Cancel");


    }



    //----------------------------------------------------------
    //loadDefaultViewModel
    //----------------------------------------------------------
    protected loadDefaultViewModel(): Observable<any> {
        let headers = new Headers({ 'Accept': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        if (this.modelType) {
            return this.http.get('app/models/device-view-models/settings/device-settings-default.json', options).map((res: Response) => res.json())
        }

        return Observable.of(null);
    }


    //----------------------------------------------------------
    //loadDisplayDriverTable
    //----------------------------------------------------------
    protected loadDisplayDriverTable() {

        //MM - Bug 128842
        let headers = new Headers({ 'Accept': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        this.http.get('app/models/video-display-drivers.json', options)
            .map((res: Response) => res.json())
            .subscribe(data => {
                this.displayDrivers = data;
            },
            err => {
                console.log(err);
            });
    }


    //-----------------------------------------------
    // getModelType
    //-----------------------------------------------
    protected getModelType() {
        return this.device.deviceInfo.model;
    }


    //----------------------------------------------------------
    //isFormClean
    //----------------------------------------------------------
    protected isFormClean() {

        let bFlag: boolean = true;
        if (this.touched) {
            bFlag = false;
        }
        else {
            bFlag = (this.formSettings) ? !this.formSettings.dirty : true;
        }

        return bFlag;

    }

    //-----------------------------------------------
    // isFusionCloudField
    //-----------------------------------------------
    protected isFusionCloudField(settingID: string) {

      let flag: boolean = false;

      switch (settingID) {

        //MM - Bug 147575
        case "s3-fusion-cloud-url-enabled":
        case "s3-fusion-cloud-url":
          flag = true;
          break;

      }
      return flag;

    }

    //-----------------------------------------------
    // isNicField
    //-----------------------------------------------
    protected isNicField(settingID: string) {

        let flag: boolean = false;

        switch (settingID) {

            //MM - Bug 144341 - HostName and Domain are NOW considered Ethernet fields
            case "host-name":
            case "domain":

            case "nic-1-dhcp":
            case "nic-1-def-router":
            case "nic-1-ip-address":
            case "nic-1-subnet-mask":
            case "nic-1-primary-dns":
            case "nic-1-secondary-dns":
            case "nic-2-dhcp":
            case "nic-2-def-router":
            case "nic-2-ip-address":
            case "nic-2-subnet-mask":
            case "nic-2-primary-dns":
            case "nic-2-secondary-dns":
                flag = true;
                break;

        }
        return flag;

    }

    //-----------------------------------------------
    // isBackgroundField
    //-----------------------------------------------
    protected isBackgroundField(settingID: string) {

        let flag: boolean = false;

        switch (settingID) {
            case "custom-background-url-1":
            case "custom-background-url-2":
            case "custom-background-url-3":
            case "custom-background-url-4":
            case "custom-background-url-5":
            case "custom-background-url-6":
            case "custom-background-url-7":
            case "custom-background-url-8":
            case "custom-background-url-9":
            case "custom-background-url-10":
            case "custom-background-url-11":
            case "custom-background-url-12":
            case "custom-background-url-13":
            case "custom-background-url-14":
            case "custom-background-url-15":
            case "custom-background-url-1-enabled":
            case "custom-background-url-2-enabled":
            case "custom-background-url-3-enabled":
            case "custom-background-url-4-enabled":
            case "custom-background-url-5-enabled":
            case "custom-background-url-6-enabled":
            case "custom-background-url-7-enabled":
            case "custom-background-url-8-enabled":
            case "custom-background-url-9-enabled":
            case "custom-background-url-10-enabled":
            case "custom-background-url-11-enabled":
            case "custom-background-url-12-enabled":
            case "custom-background-url-13-enabled":
            case "custom-background-url-14-enabled":
            case "custom-background-url-15-enabled":
                flag = true;
                break;

        }
        return flag;

    }

    //-----------------------------------------------
    // isAirMedia Connection Display options
    //-----------------------------------------------
    protected isAirmediaDisplay(settingID: string) {
        let flag: boolean = false;


        switch (settingID) {
            case "airmedia-display-ipaddress":
            case "airmedia-display-hostname":
            case "airmedia-display-domainname":
            case "airmedia-display-custom-string":
            case "airmedia-custom-string":
                flag = true;
                break;

        }
        return flag;
    }

    //-----------------------------------------------
    // isVideoDisplayField
    //-----------------------------------------------
    protected isVideoDisplayField(settingID: string) {

        let flag: boolean = false;


        switch (settingID) {
            case "video-display-name":
            case "video-display-model":
            case "video-display-driver-control":
            case "video-display-default-input":
            case "video-display-driver-baud-rate":
            case "video-display-driver-ip-id":
            case "video-display-driver-channel":
            case "video-display-driver-ip-address":
            case "video-display-driver-port":
            case "video-display-driver-id":
                flag = true;
                break;

        }
        return flag;

    }




    //-----------------------------------------------
    // isSpecialCase
    //-----------------------------------------------
    protected isSpecialCase(settingID: string): boolean {

        let bFlag: boolean = false;
        if (this.device) {
          //MM - Bug 147575 - Added check for Fusion Cloud
          //MM - Bug 142416 - Added check for Video Display
          bFlag = (this.changedFusionCloud && this.isFusionCloudField(settingID))
                          || this.changedVideoDisplay && this.isVideoDisplayField(settingID)
                          || (this.changedNIC && this.isNicField(settingID))
                          || (this.changedBackground && this.isBackgroundField(settingID)
                          || (this.changedAirMediaConnection && this.isAirmediaDisplay(settingID)));
        }

        return bFlag;

    }

    //-----------------------------------------------
    // setValueOnModel
    //-----------------------------------------------
    protected setValueOnModel(settingID: string, model: Device, loggingCallback?:any) {


        try {

            let customPath: string;
            let params: any = {};
            let controls: any = this.formSettings.controls;

            if (controls[settingID]) {
                params = this.getModelParams(controls[settingID].model);
            }

            //Very special case.. because this value has no actual control visible to the user
            if (settingID === "video-display-driver-id" && this.changedVideoDisplay) {

                let driverSetting: DeviceControlModel = new DeviceControlModel();
                driverSetting.id = "video-display-driver-id";
                params = this.getModelParams(driverSetting);

                //Make sure parent objects are initialized based on what's selected
                this.prepareParent(model, params.hardPath);
                objectPath.set(model, params.hardPath, this.displayDriverID);
                return;

            }



            //If setting control exists, and has a model, is visible to the user, and either [selected] or a [NIC field] when NIC has changed
            if (controls[settingID] &&
                controls[settingID].model &&
                controls[settingID].model.visible &&
                (controls[settingID].model.apply || this.isSpecialCase(settingID))) {


                //MM - If it's a device setting, check for dirty.. unless it's a special case ....
                if ((this.device && (controls[settingID].dirty || this.isSpecialCase(settingID)))) { //MM- Apparently, even for Group Settings we should only send down what's been changed..

                    //Make sure parent objects are initialized based on what's selected
                    this.prepareParent(model, params.hardPath);


                    switch (settingID) {

                        // Custom behavior for..


                        //MM - Bug 129724 - Send down NONE if blank
                        case "sip-proxy-server":

                            let sipServerVal: any;
                            if (controls[settingID]) {
                                sipServerVal = controls[settingID].value;
                                if (sipServerVal.toString().trim() === "") {
                                    sipServerVal = "NONE";
                                }
                            }
                            objectPath.set(model, params.hardPath, sipServerVal);

                            break;

                        //MM - Bug 142416 - Display Model and Driver Control SHOULD not persist in outstanding updates
                        case "video-display-model":
                        case "video-display-driver-control":
                            //...So do nothing here... just break; to avoid setting value on model
                            break;

                        //MM - Domain Name SHOULD NOT persist in outstanding updates
                        //MM - Bugs [128723,128814] - DnsServers, Addresses (ip and subnet) and DefaultGateway SHOULD NOT persist in outstanding updates
                        //MM - Bugs [128723,128814] - staticDNS, staticAddresses  (ip and subnet) and staticDefaultGateway SHOULD persist in outstanding updates

                        case "domain":

                        case "nic-1-def-router":
                        case "nic-1-ip-address":
                        case "nic-1-subnet-mask":
                        case "nic-1-primary-dns":
                        case "nic-1-secondary-dns":

                        case "nic-2-def-router":
                        case "nic-2-ip-address":
                        case "nic-2-subnet-mask":
                        case "nic-2-primary-dns":
                        case "nic-2-secondary-dns":



                            if (controls["nic-1-dhcp"]) {
                                let dhcpValue: boolean = controls["nic-1-dhcp"].value;
                                if (dhcpValue) {
                                    //MM - Domain Name SHOULD NOT persist in outstanding updates
                                    //MM - Bugs [128723,128814] - DnsServers, Addresses (ip and subnet) and DefaultGateway SHOULD not persist in outstanding updates
                                    //...So do nothing here..
                                    //objectPath.set(model, params.hardPath, null);
                                }
                                else {
                                    //MM - Bugs [128723,128814] - staticDNS, staticAddresses (ip and subnet) and staticDefaultGateway SHOULD persist in outstanding updates
                                    (controls[settingID]) && (objectPath.set(model, params.hardPath, controls[settingID].value));
                                }
                            }

                            break;

                        case "nic-1-dhcp":
                            //DHCP applies to both adapters!
                            if (controls[settingID]) {
                                let dhcpValue: boolean = controls["nic-1-dhcp"].value;

                                customPath = "ethernet.adapters.0.iPv4.isDhcpEnabled";
                                objectPath.set(model, customPath, dhcpValue);

                                //MM - Bug 137702
                                if (this.modelTypesForCFA()) {
                                    customPath = "ethernet.adapters.1.iPv4.isDhcpEnabled";
                                    objectPath.set(model, customPath, dhcpValue);
                                }
                                else {
                                    objectPath.del(model, "ethernet.adapters.1");
                                }
                            }

                            break;

                        case "time-setting":

                            let valUTC: Date = new Date(controls[settingID].value.getTime() + controls[settingID].value.getTimezoneOffset() * 60000);
                            (controls[settingID]) && (objectPath.set(model, params.hardPath, valUTC));

                            break;
                        case "airmedia-assigned-ethernet-port":
                        case "assigned-sip-ethernet-port":

                            switch (controls[settingID].value) {

                                //MM - Bug 124200 - 'Both' is no longer supported
                                case true://"main":
                                    objectPath.set(model, params.hardPath + ".0", "eth0");

                                    break;
                                case false://"aux":

                                    objectPath.set(model, params.hardPath + ".0", "eth1");

                                    break;


                            }

                            break;


                        //SA - Bug 147160 - Send down null if empty string
                        case "airmedia-custom-string":

                            let airmedialogincode: any;
                            if (controls[settingID]) {
                                airmedialogincode = controls[settingID].value;
                                if (airmedialogincode.toString().trim() === "") {
                                    airmedialogincode = null;
                                }
                            }
                            objectPath.set(model, params.hardPath, airmedialogincode.toString().trim());

                            break;



                        default:
                            //Default Behavior for MOST settings
                            let valueToSet: any;
                            if (!controls[settingID] || controls[settingID].value === null) {
                                valueToSet = params.defaultValue;
                            }
                            else {
                                valueToSet = controls[settingID].value;
                            }
                            objectPath.set(model, params.hardPath, valueToSet);

                            break;
                    }

                    //Instead of custom code, let's execute the callback
                    if (loggingCallback) {
                        loggingCallback(settingID, model, params);
                    }

                }
            }
            else {
                //Very special case..
                if (settingID !== "video-display-driver-id") {

                    //If setting is UNCHECKED try to remove it from the model
                    if (objectPath.has(model, params.hardPath)) {
                        objectPath.del(model, params.hardPath);
                    }


                }

            }


        }
        catch (e) {
            console.log("Error-->setValueOnModel(" + settingID + ")");
        }


    }

    //-----------------------------------------------
    // setValueOnModelCFA
    //-----------------------------------------------
    protected setValueOnModelCFA(settingID: string, model: Device, loggingCallback?: any) {


        try {

            let customPath: string;
            let params: any = {};
            let controls: any = this.formSettings.controls;

            if (controls[settingID]) {
                params = this.getModelParams(controls[settingID].model);
            }

            //Very special case.. because this value has no actual control visible to the user
            if (settingID === "video-display-driver-id" && this.changedVideoDisplay) {

                let driverSetting: DeviceControlModel = new DeviceControlModel();
                driverSetting.id = "video-display-driver-id";
                params = this.getModelParams(driverSetting);

                //Make sure parent objects are initialized based on what's selected
                this.prepareParent(model, params.hardPath);
                objectPath.set(model, params.hardPath, this.displayDriverID);
                return;

            }


            //If setting control exists, and has a model, is visible to the user, and either [selected] or a [NIC field] when NIC has changed
            if (controls[settingID] &&
                controls[settingID].model &&
                controls[settingID].model.visible &&
                (controls[settingID].model.apply || this.isSpecialCase(settingID))) {


                //MM - If it's a device setting, check for dirty.. unless it's a special case ....
                if ((this.device && (controls[settingID].dirty || this.isSpecialCase(settingID)))) { //MM- Apparently, even for Group Settings we should only send down what's been changed..
                    //if ( controls[settingID].dirty || this.isSpecialCase(settingID)  ) { //MM- Don't enable this line of code, until we are sure that SetFull or SetPartial operations are properly set.

                    //Make sure parent objects are initialized based on what's selected
                    this.prepareParent(model, params.hardPath);


                    switch (settingID) {

                        // Custom behavior for..


                        //MM - Bug 129724 - Send down NONE if blank
                        case "sip-proxy-server":

                            let sipServerVal: any;
                            if (controls[settingID]) {
                                sipServerVal = controls[settingID].value;
                                if (sipServerVal.toString().trim() === "") {
                                    sipServerVal = "NONE";
                                }
                            }
                            objectPath.set(model, params.hardPath, sipServerVal);

                            break;

                        //MM - Domain Name SHOULD not persist in outstanding updates
                        //MM - Bugs [128723,128814] - DnsServers, Addresses (ip and subnet) and DefaultGateway SHOULD NOT persist in outstanding updates
                        //MM - Bugs [128723,128814] - staticDNS, staticAddresses  (ip and subnet) and staticDefaultGateway SHOULD persist in outstanding updates

                        case "domain":
                        case "nic-1-def-router":
                        case "nic-1-ip-address":
                        case "nic-1-subnet-mask":


                            if (controls["nic-1-dhcp"]) {
                                let dhcpValue: boolean = controls["nic-1-dhcp"].value;
                                if (dhcpValue) {
                                    //MM - Domain Name SHOULD not persist in outstanding updates
                                    //MM - Bugs [128723,128814] - DnsServers, Addresses (ip and subnet) and DefaultGateway SHOULD not persist in outstanding updates
                                    //...So do nothing here..
                                    //objectPath.set(model, params.hardPath, null);

                                }
                                else {

                                    //MM - Bugs [128723,128814] - staticDNS, staticAddresses (ip and subnet) and staticDefaultGateway SHOULD persist in outstanding updates
                                    //DualNICs... yet another special case.. primary and secondary DNS should apply to both NICs on Device Model
                                    //if (settingID === "nic-1-primary-dns") {
                                    //    (controls["nic-1-primary-dns"]) && (objectPath.set(model, params.hardPath, controls["nic-1-primary-dns"].value));
                                    //    let nic2setting: DeviceControlModel = new DeviceControlModel();
                                    //    nic2setting.id = "nic-2-primary-dns";
                                    //    customPath = this.getModelParams(nic2setting).hardPath;
                                    //    (controls["nic-1-primary-dns"]) && (objectPath.set(model, customPath, controls["nic-1-primary-dns"].value));
                                    //}
                                    //else if (settingID === "nic-1-secondary-dns") {
                                    //    (controls["nic-1-secondary-dns"]) && (objectPath.set(model, params.hardPath, controls["nic-1-secondary-dns"].value));
                                    //    let nic2setting: DeviceControlModel = new DeviceControlModel();
                                    //    nic2setting.id = "nic-2-secondary-dns";
                                    //    customPath = this.getModelParams(nic2setting).hardPath;
                                    //    (controls["nic-1-secondary-dns"]) && (objectPath.set(model, customPath, controls["nic-1-secondary-dns"].value));
                                    //}
                                    //else {
                                    (controls[settingID]) && (objectPath.set(model, params.hardPath, controls[settingID].value));
                                    //}

                                }
                            }

                            break;

                        case "nic-1-primary-dns":
                        case "nic-1-secondary-dns":

                            if (controls["nic-1-dhcp"]) {
                                //this pice of code moved out from above else condition because Adapater1 Static Primary & Secondary DNS values should keep one copy into Adapater2 though DHCP is enabled/disabled
                                if (settingID === "nic-1-primary-dns") {

                                    (controls["nic-1-primary-dns"]) && (objectPath.set(model, params.hardPath, controls["nic-1-primary-dns"].value));
                                    //MM - Make sure this device has a second adapter
                                    if (controls["nic-2-dhcp"]) {
                                      let nic2setting: DeviceControlModel = new DeviceControlModel();
                                      nic2setting.id = "nic-2-primary-dns";
                                      customPath = this.getModelParams(nic2setting).hardPath;
                                      (controls["nic-1-primary-dns"]) && (objectPath.set(model, customPath, controls["nic-1-primary-dns"].value));
                                    }
                                }
                                else if (settingID === "nic-1-secondary-dns") {

                                    (controls["nic-1-secondary-dns"]) && (objectPath.set(model, params.hardPath, controls["nic-1-secondary-dns"].value));
                                    //MM - Make sure this device has a second adapter
                                    if (controls["nic-2-dhcp"]) {
                                      let nic2setting: DeviceControlModel = new DeviceControlModel();
                                      nic2setting.id = "nic-2-secondary-dns";
                                      customPath = this.getModelParams(nic2setting).hardPath;
                                      (controls["nic-1-secondary-dns"]) && (objectPath.set(model, customPath, controls["nic-1-secondary-dns"].value));
                                    }
                                }

                            }

                            break;

                        case "nic-2-def-router":
                        case "nic-2-ip-address":
                        case "nic-2-subnet-mask":


                            if (controls["nic-2-dhcp"]) {
                                let dhcpValue: boolean = controls["nic-2-dhcp"].value;
                                if (dhcpValue) {
                                    //MM - Domain Name SHOULD not persist in outstanding updates
                                    //MM - Bugs [128723,128814] - DnsServers, Addresses (ip and subnet) and DefaultGateway SHOULD not persist in outstanding updates
                                    //...So do nothing here..
                                    //objectPath.set(model, params.hardPath, null);

                                }
                                else {
                                    //MM - Bugs [128723,128814] - staticDNS, staticAddresses (ip and subnet) and staticDefaultGateway SHOULD persist in outstanding updates
                                    (controls[settingID]) && (objectPath.set(model, params.hardPath, controls[settingID].value));
                                }
                            }

                            break;


                        case "time-setting":

                            let valUTC: Date = new Date(controls[settingID].value.getTime() + controls[settingID].value.getTimezoneOffset() * 60000);
                            (controls[settingID]) && (objectPath.set(model, params.hardPath, valUTC));

                            break;
                        case "airmedia-assigned-ethernet-port":
                        case "assigned-sip-ethernet-port":

                            switch (controls[settingID].value) {

                                //MM - Bug 124200 - 'Both' is no longer supported
                                case true://"main":
                                    objectPath.set(model, params.hardPath + ".0", "eth0");

                                    break;
                                case false://"aux":

                                    objectPath.set(model, params.hardPath + ".0", "eth1");

                                    break;

                                //MM - Bug 124200 - 'Both' is no longer supported
                                //case "both":
                                //    objectPath.set(model, params.hardPath + ".0", "eth0");
                                //    objectPath.set(model, params.hardPath + ".1", "eth1");
                                //    break;

                            }

                            break;


                        default:
                            //Default Behavior for MOST settings
                            let valueToSet: any;
                            if (!controls[settingID] || controls[settingID].value === null) {
                                valueToSet = params.defaultValue;
                            }
                            else {
                                valueToSet = controls[settingID].value;
                            }
                            objectPath.set(model, params.hardPath, valueToSet);

                            break;
                    }


                    //Instead of custom code, let's execute the callback
                    if (loggingCallback) {
                        loggingCallback(settingID, model, params);
                    }

                }
            }
            else {
                //Very special case..
                if (settingID !== "video-display-driver-id") {

                    //If setting is UNCHECKED try to remove it from the model
                    if (objectPath.has(model, params.hardPath)) {
                        objectPath.del(model, params.hardPath);
                    }


                }

            }


        }
        catch (e) {
            console.log("Error-->setValueOnModelCFA(" + settingID + ")");
        }


    }

    //----------------------------------------------------------
    //setCrestronValidation
    //----------------------------------------------------------
    protected setCrestronValidation(control: any) {



        try {
            if (control) {
                let setting: DeviceControlModel = control.model;

                if (setting.type === DeviceControlType.TextBox || setting.type === DeviceControlType.Password || setting.type === DeviceControlType.Time) {

                    //MM - If a validator is available in the JSON, use it.
                    if (setting.validator && setting.validator.toString().trim() !== "" && this.validationService[setting.validator]) {
                        control.setValidators(this.validationService[setting.validator]);
                    }
                    else {
                        switch (setting.id) {


                            case "time-setting":
                                control.setValidators([this.validationService.Time]);
                                break;

                            case "fusion-cloud-url":

                                control.setValidators([this.validationService.CloudURL]);

                                break;


                            case "fusion-room-name":
                                control.setValidators([this.validationService.RoomName]);
                                break;

                            case "friendly-system-name":
                                control.setValidators([this.validationService.SystemName]);
                                break;


                            case "video-display-driver-channel":
                                control.setValidators([this.validationService.Channel]);
                                break;

                            case "device-password":
                            case "device-password-confirm":

                                control.setValidators([this.validationService.Password]);

                                break;

                            case "sip-port":
                                control.setValidators([this.validationService.Port]);
                                break;
                            case "sip-proxy-server":
                                control.setValidators([this.validationService.ProxyServer]);
                                break;


                            case "sip-server-ip-address":
                                control.setValidators([this.validationService.IPorHostName]);
                                break;
                            case "sip-server-username":
                                control.setValidators([this.validationService.UserName]);
                                break;
                            case "sip-server-password":
                                control.setValidators([this.validationService.ServerPassword]);
                                break;
                            case "sip-server-realm":
                                control.setValidators([this.validationService.Realm]);
                                break;
                            case "sip-local-extension":
                                control.setValidators([this.validationService.LocalExtension]);
                                break;
                            case "sip-display-extension":
                                control.setValidators([this.validationService.DisplayExtensionAPPSPACE]);
                                break;


                            case "custom-time-server":

                                control.setValidators([this.validationService.Server]);
                                break;


                            case "friendly-bluetooth-name":

                                control.setValidators([Validators.required,this.validationService.Bluetooth]);
                                break;

                            case "emergency-broadcast-timeout":
                            case "non-emergency-broadcast-timeout":
                            case "call-notification-timeout":
                            case "time-remaining-message-starts-minutes":
                            case "time-remaining-message-duration-seconds":

                                control.setValidators([this.validationService.Minutes]);
                                break;


                            case "interval-between-backgrounds":

                                control.setValidators([this.validationService.BackgroundInterval]);
                                break;


                            case "next-meeting-information-minutes-before-meeting-start":

                                control.setValidators([this.validationService.MinutesLong]);
                                break;

                            case "speedkey-1-name":
                            case "speedkey-2-name":
                            case "speedkey-3-name":
                            case "speedkey-4-name":
                            case "speedkey-5-name":

                                control.setValidators([this.validationService.SpeedKeyName]);
                                break;


                            case "speedkey-1-number":
                            case "speedkey-2-number":
                            case "speedkey-3-number":
                            case "speedkey-4-number":
                            case "speedkey-5-number":

                                control.setValidators([this.validationService.SpeedKey]);
                                break;

                            //MM  - Temporary fix for different HostName validations for CE devices.
                            case "host-name":
                                if (this.modelTypesForCFA()) {
                                    control.setValidators(this.validationService.HostName);
                                }
                                else {
                                    control.setValidators(this.validationService.HostNameCE);
                                }
                                break;


                            case "domain":

                                //MM - Bug 144871 - DeviceViewModels for 3 series and DMPS should use [DomainCE], all else can use [Domain]
                                control.setValidators(this.validationService.Domain);


                                break;

                            case "outlook-domain-name":

                                control.setValidators([this.validationService.DomainName]);

                                break;

                            case "outlook-user-email-address":
                                control.setValidators([this.validationService.SchedulingUserName]);

                                break;

                            case "outlook-password":

                                control.setValidators([this.validationService.SchedulingPassword]);

                                break;


                            case "outlook-resource-address":

                                control.setValidators([this.validationService.Email]);
                                break;


                            case "airmedia-login-code":

                                control.setValidators([this.validationService.LoginCode]);
                                break;

                            case "video-display-driver-port":

                                control.setValidators([this.validationService.DisplayPort]);

                                break;

                            case "video-display-driver-ip-address":
                            case "nic-1-def-router":
                            case "nic-1-ip-address":
                            case "nic-1-subnet-mask":
                            case "nic-1-primary-dns":
                            case "nic-1-secondary-dns":
                            case "nic-2-def-router":
                            case "nic-2-ip-address":
                            case "nic-2-subnet-mask":
                            case "nic-2-primary-dns":
                            case "nic-2-secondary-dns":

                                control.setValidators([this.validationService.IpAddress]);
                                break;



                            case "outlook-web-access-url":
                            case "custom-background-url-1":
                            case "custom-background-url-2":
                            case "custom-background-url-3":
                            case "custom-background-url-4":
                            case "custom-background-url-5":
                            case "custom-background-url-6":
                            case "custom-background-url-7":
                            case "custom-background-url-8":
                            case "custom-background-url-9":
                            case "custom-background-url-10":
                            case "custom-background-url-11":
                            case "custom-background-url-12":
                            case "custom-background-url-13":
                            case "custom-background-url-14":
                            case "custom-background-url-15":

                                control.setValidators([this.validationService.URL]);
                                break;
                            case "custom-logo-graphic-url":
                                control.setValidators([Validators.required, this.validationService.URL]);
                                break;

                            case "video-display-name":
                            case "speedkey-1-name":
                            case "speedkey-2-name":
                            case "speedkey-3-name":
                            case "speedkey-4-name":
                            case "speedkey-5-name":

                                control.setValidators([Validators.maxLength(20)]);
                                break;

                            case "cable-connection-details":

                                control.setValidators([Validators.maxLength(30)]);
                                break;


                            case "hdmi-output-name":

                                control.setValidators([Validators.maxLength(50)]);
                                break;

                            case "sfb-username":

                                control.setValidators([Validators.required, Validators.maxLength(256), this.validationService.UPN]);
                                break;

                            case "sfb-password":

                                control.setValidators([Validators.required, Validators.maxLength(128)]);
                                break;

                            case "sfb-sip-address":

                                control.setValidators([Validators.required, this.validationService.Email, Validators.maxLength(256)]);
                                break;

                            case "sfb-internal-server-name":

                                control.setValidators([this.validationService.ExternalURL, Validators.maxLength(256)]);
                                break;

                            case "sfb-external-server-name":

                                control.setValidators([this.validationService.ExternalURL, Validators.maxLength(256)]);
                                break;

                            case "sfb-proxy-username":

                                control.setValidators([Validators.maxLength(256), this.validationService.UPN]);
                                break;

                            case "sfb-proxy-password":

                                control.setValidators([Validators.maxLength(128)]);
                                break;
                            case "sfb-display-extension":

                                control.setValidators([this.validationService.DisplayExtensionSFBAPPSPACE]);
                                break;

                            case "sfb-preset-1-name":
                            case "sfb-preset-2-name":
                            case "sfb-preset-3-name":
                            case "sfb-preset-4-name":

                                control.setValidators([Validators.required, this.validationService.UPN, Validators.maxLength(64)]);
                                break;

                            case "s3-fusion-cloud-url":
                                control.setValidators([this.validationService.CloudURL]);
                                break;
                            case "airmedia-custom-string": //SA CFA change.

                                control.setValidators([Validators.required, this.validationService.CustomStringCFA]);
                                break;

                            case "appspace-server-url": //Appspace change.

                                control.setValidators([this.validationService.ServerURLAppSpace]);
                                break;

                            default:


                                break;



                        }
                    }
                }

            }
        }
        catch (e) {
            console.log("Error-->setValidators()" + control);
        }


    }

    //-----------------------------------------------
    // prepareDevice
    //-----------------------------------------------
    protected prepareDevice(myDevice: Device) {


        try {
            (!myDevice.action) && (myDevice.action = new MergeAction());
            (!myDevice.action.deliveryState) && (myDevice.action.deliveryState = DeliveryStateEnum.Pending);
            (!myDevice.action.operations) && (myDevice.action.operations = this.buildDeviceOperations());

            //-----------------------------------------------
            // Devices Level Objects
            //-----------------------------------------------

            (!myDevice.ethernet) && (myDevice.ethernet = new Ethernet());
            (!myDevice.ethernet.adapters) && (myDevice.ethernet.adapters = new Array<Adapter>());
            (!myDevice.ethernet.adapters[0]) && (myDevice.ethernet.adapters.push(new Adapter()));
            (!myDevice.ethernet.adapters[0].iPv4) && (myDevice.ethernet.adapters[0].iPv4 = new IPAddr());

            //MM - DHCP switch - Create both
            (!myDevice.ethernet.adapters[0].iPv4.addresses) && (myDevice.ethernet.adapters[0].iPv4.addresses = new Array<Addresses>());
            (!myDevice.ethernet.adapters[0].iPv4.addresses[0]) && (myDevice.ethernet.adapters[0].iPv4.addresses.push(new Addresses()));
            (!myDevice.ethernet.adapters[0].iPv4.staticAddresses) && (myDevice.ethernet.adapters[0].iPv4.staticAddresses = new Array<Addresses>());
            (!myDevice.ethernet.adapters[0].iPv4.staticAddresses[0]) && (myDevice.ethernet.adapters[0].iPv4.staticAddresses.push(new Addresses()));

            (!myDevice.ethernet.adapters[0].iPv4.dnsServers) && (myDevice.ethernet.adapters[0].iPv4.dnsServers = new Array<string>());
            (!myDevice.ethernet.adapters[0].iPv4.dnsServers[0]) && (myDevice.ethernet.adapters[0].iPv4.dnsServers.push(""));
            (!myDevice.ethernet.adapters[0].iPv4.dnsServers[1]) && (myDevice.ethernet.adapters[0].iPv4.dnsServers.push(""));

            //MM - PRODUCTION ISSUE - Adapter 1
            (!myDevice.ethernet.adapters[0].iPv4.staticDns) && (myDevice.ethernet.adapters[0].iPv4.staticDns = new Array<string>());
            (!myDevice.ethernet.adapters[0].iPv4.staticDns[0]) && (myDevice.ethernet.adapters[0].iPv4.staticDns.push(""));
            (!myDevice.ethernet.adapters[0].iPv4.staticDns[1]) && (myDevice.ethernet.adapters[0].iPv4.staticDns.push(""));


            (!myDevice.ethernet.adapters[1]) && (myDevice.ethernet.adapters.push(new Adapter()));
            (!myDevice.ethernet.adapters[1].iPv4) && (myDevice.ethernet.adapters[1].iPv4 = new IPAddr());

            //MM - DHCP switch - Create both
            (!myDevice.ethernet.adapters[1].iPv4.addresses) && (myDevice.ethernet.adapters[1].iPv4.addresses = new Array<Addresses>());
            (!myDevice.ethernet.adapters[1].iPv4.addresses[0]) && (myDevice.ethernet.adapters[1].iPv4.addresses.push(new Addresses()));
            (!myDevice.ethernet.adapters[1].iPv4.staticAddresses) && (myDevice.ethernet.adapters[1].iPv4.staticAddresses = new Array<Addresses>());
            (!myDevice.ethernet.adapters[1].iPv4.staticAddresses[0]) && (myDevice.ethernet.adapters[1].iPv4.staticAddresses.push(new Addresses()));

            (!myDevice.ethernet.adapters[1].iPv4.dnsServers) && (myDevice.ethernet.adapters[1].iPv4.dnsServers = new Array<string>());
            (!myDevice.ethernet.adapters[1].iPv4.dnsServers[0]) && (myDevice.ethernet.adapters[1].iPv4.dnsServers.push(""));
            (!myDevice.ethernet.adapters[1].iPv4.dnsServers[1]) && (myDevice.ethernet.adapters[1].iPv4.dnsServers.push(""));

            //MM - PRODUCTION ISSUE - Adapter 2
            (!myDevice.ethernet.adapters[1].iPv4.staticDns) && (myDevice.ethernet.adapters[1].iPv4.staticDns = new Array<string>());
            (!myDevice.ethernet.adapters[1].iPv4.staticDns[0]) && (myDevice.ethernet.adapters[1].iPv4.staticDns.push(""));
            (!myDevice.ethernet.adapters[1].iPv4.staticDns[1]) && (myDevice.ethernet.adapters[1].iPv4.staticDns.push(""));


            (!myDevice.licenseRegistry) && (myDevice.licenseRegistry = new LicenseRegistry());
            (!myDevice.autoUpdateMaster) && (myDevice.autoUpdateMaster = new AutoUpdateMaster());
            (!myDevice.autoUpdateMaster.deviceCredentials) && (myDevice.autoUpdateMaster.deviceCredentials = new Credentials());

            (!myDevice.fusionCloud) && (myDevice.fusionCloud = new FusionCloud());
            (!myDevice.sip) && (myDevice.sip = new FWSIP());
            (!myDevice.systemClock) && (myDevice.systemClock = new SystemClock());
            (!myDevice.systemClock.sntp) && (myDevice.systemClock.sntp = new Sntp());
            (!myDevice.systemVersions) && (myDevice.systemVersions = new SystemVersions());
            (!myDevice.airMedia) && (myDevice.airMedia = new AirMedia());
            (!myDevice.airMedia.connectionDisplayOptions) && (myDevice.airMedia.connectionDisplayOptions = new ConnectionDisplayOptions());
            (!myDevice.audioVideoInputOutput) && (myDevice.audioVideoInputOutput = new AudioVideoInputOutput());
            (!myDevice.app) && (myDevice.app = new App());

            //-----------------------------------------------
            // AVF Level Objects
            //-----------------------------------------------
            (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());
            (!myDevice.app.config.audioDevices) && (myDevice.app.config.audioDevices = new AudioDevices());
            (!myDevice.app.config.fusionSetup) && (myDevice.app.config.fusionSetup = new FusionSetup());
            (!myDevice.app.config.general) && (myDevice.app.config.general = new General());
            (!myDevice.app.config.runTimeSettings) && (myDevice.app.config.runTimeSettings = new RunTimeSettings());
            (!myDevice.app.config.scheduling) && (myDevice.app.config.scheduling = new Scheduling());
            (!myDevice.app.config.timeOptions) && (myDevice.app.config.timeOptions = new TimeOptions());
            (!myDevice.app.config.videoDisplay) && (myDevice.app.config.videoDisplay = new VideoDisplay());
            (!myDevice.app.config.runTimeSettings.logo) && (myDevice.app.config.runTimeSettings.logo = new Logo());
            (!myDevice.app.config.audioDevices.bluetooth) && (myDevice.app.config.audioDevices.bluetooth = new Bluetooth());
            (!myDevice.app.config.audioDevices.uSB) && (myDevice.app.config.audioDevices.uSB = new USB());
            (!myDevice.app.config.audioDevices.sIP) && (myDevice.app.config.audioDevices.sIP = new SIP);
            (!myDevice.app.config.audioDevices.sFB) && (myDevice.app.config.audioDevices.sFB = new SFB());
            (!myDevice.app.config.audioDevices.sIP.regexs) && (myDevice.app.config.audioDevices.sIP.regexs = new Array<string>());


            //More setup work..
            (!myDevice.app.config.runTimeSettings.backgrounds) && (myDevice.app.config.runTimeSettings.backgrounds = new Background());
            (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList) && (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList = new Array<CustomBackground>());

            (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[0]) &&
                (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));
            (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[1]) &&
                (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));
            (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[2]) &&
                (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));
            (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[3]) &&
                (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));
            (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[4]) &&
                (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));
            (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[5]) &&
                (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));
            (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[6]) &&
                (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));
            (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[7]) &&
                (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));
            (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[8]) &&
                (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));
            (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[9]) &&
                (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));
            (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[10]) &&
                (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));
            (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[11]) &&
                (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));
            (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[12]) &&
                (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));
            (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[13]) &&
                (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));
            (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[14]) &&
                (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));


            (!myDevice.app.config.audioDevices.sIP.speedKeys) && (myDevice.app.config.audioDevices.sIP.speedKeys = new Array<Speedkey>());
            (!myDevice.app.config.audioDevices.sIP.speedKeys[0]) &&
                (myDevice.app.config.audioDevices.sIP.speedKeys.push(new Speedkey()));
            (!myDevice.app.config.audioDevices.sIP.speedKeys[1]) &&
                (myDevice.app.config.audioDevices.sIP.speedKeys.push(new Speedkey()));
            (!myDevice.app.config.audioDevices.sIP.speedKeys[2]) &&
                (myDevice.app.config.audioDevices.sIP.speedKeys.push(new Speedkey()));
            (!myDevice.app.config.audioDevices.sIP.speedKeys[3]) &&
                (myDevice.app.config.audioDevices.sIP.speedKeys.push(new Speedkey()));
            (!myDevice.app.config.audioDevices.sIP.speedKeys[4]) &&
                (myDevice.app.config.audioDevices.sIP.speedKeys.push(new Speedkey()));

            (!myDevice.app.config.audioDevices.sFB.presets) && (myDevice.app.config.audioDevices.sFB.presets = new Array<Preset>());
            (!myDevice.app.config.audioDevices.sFB.presets[0]) &&
                (myDevice.app.config.audioDevices.sFB.presets.push(new Preset()));
            (!myDevice.app.config.audioDevices.sFB.presets[1]) &&
                (myDevice.app.config.audioDevices.sFB.presets.push(new Preset()));
            (!myDevice.app.config.audioDevices.sFB.presets[2]) &&
                (myDevice.app.config.audioDevices.sFB.presets.push(new Preset()));
            (!myDevice.app.config.audioDevices.sFB.presets[3]) &&
                (myDevice.app.config.audioDevices.sFB.presets.push(new Preset()));

            //Zoom Room Mode
            (!myDevice.thirdPartyApplications) && (myDevice.thirdPartyApplications = new ThirdPartyApplications());
            (!myDevice.thirdPartyApplications.zoomRoom) && (myDevice.thirdPartyApplications.zoomRoom = new ZoomRoom());

            //3 Series device objecy preparation
            (!myDevice.cloudSettings) && (myDevice.cloudSettings = new CloudSettings());
            (!myDevice.cloudSettings.fusionCloud) && (myDevice.cloudSettings.fusionCloud = new FusionCloud2());

        }
        catch (e) {
            console.log("Error-->prepareDevice()");
        }
    }

    //-----------------------------------------------
    // prepareParent
    //-----------------------------------------------
    protected prepareParent(myDevice: Device, hardPath: string) {

        let parentFull: Array<string> = hardPath.split(".");
        parentFull.pop();
        let parentID: string = parentFull.join(".");
        let controls: any = this.formSettings.controls;

        let thisOperation: DeviceOperation;
        thisOperation = new DeviceOperation();
        thisOperation.operation = OperationEnum.SetPartial;

        //MM - For Ethernet, make sure to set operation to FULL, since all NIC fields go down together
        switch (parentID) {

            case "ethernet":
                thisOperation.operation = OperationEnum.SetFull;
                thisOperation.targetObject = "Ethernet";
                (!myDevice.ethernet) && (myDevice.ethernet = new Ethernet());
                break;

            case "ethernet.adapters":
                thisOperation.operation = OperationEnum.SetFull;
                thisOperation.targetObject = "Ethernet";
                (!myDevice.ethernet) && (myDevice.ethernet = new Ethernet());
                (!myDevice.ethernet.adapters) && (myDevice.ethernet.adapters = new Array<Adapter>());
                break;

            case "ethernet.adapters.0":
                thisOperation.operation = OperationEnum.SetFull;
                thisOperation.targetObject = "Ethernet";
                (!myDevice.ethernet) && (myDevice.ethernet = new Ethernet());
                (!myDevice.ethernet.adapters) && (myDevice.ethernet.adapters = new Array<Adapter>());
                (!myDevice.ethernet.adapters[0]) && (myDevice.ethernet.adapters.push(new Adapter()));
                break;
            case "ethernet.adapters.0.iPv4":
                thisOperation.operation = OperationEnum.SetFull;
                thisOperation.targetObject = "Ethernet";
                (!myDevice.ethernet) && (myDevice.ethernet = new Ethernet());
                (!myDevice.ethernet.adapters) && (myDevice.ethernet.adapters = new Array<Adapter>());

                //MM- Do both adapters
                (!myDevice.ethernet.adapters[0]) && (myDevice.ethernet.adapters.push(new Adapter()));
                (!myDevice.ethernet.adapters[0].iPv4) && (myDevice.ethernet.adapters[0].iPv4 = new IPAddr());

                //MM - Bug 137702
                if (this.modelType === "MERCURY") {
                    (!myDevice.ethernet.adapters[1]) && (myDevice.ethernet.adapters.push(new Adapter()));
                    (!myDevice.ethernet.adapters[1].iPv4) && (myDevice.ethernet.adapters[1].iPv4 = new IPAddr());
                }



                break;

            case "ethernet.adapters.0.iPv4.addresses":
            case "ethernet.adapters.0.iPv4.staticAddresses":
                thisOperation.operation = OperationEnum.SetFull;
                thisOperation.targetObject = "Ethernet";
                (!myDevice.ethernet) && (myDevice.ethernet = new Ethernet());
                (!myDevice.ethernet.adapters) && (myDevice.ethernet.adapters = new Array<Adapter>());
                (!myDevice.ethernet.adapters[0]) && (myDevice.ethernet.adapters.push(new Adapter()));
                (!myDevice.ethernet.adapters[0].iPv4) && (myDevice.ethernet.adapters[0].iPv4 = new IPAddr());

                //MM - DHCP switch
                (!myDevice.ethernet.adapters[0].iPv4.addresses) && (myDevice.ethernet.adapters[0].iPv4.addresses = new Array<Addresses>());
                (!myDevice.ethernet.adapters[0].iPv4.staticAddresses) && (myDevice.ethernet.adapters[0].iPv4.staticAddresses = new Array<Addresses>());

                break;
            case "ethernet.adapters.0.iPv4.addresses.0":
            case "ethernet.adapters.0.iPv4.staticAddresses.0":
                thisOperation.operation = OperationEnum.SetFull;
                thisOperation.targetObject = "Ethernet";
                (!myDevice.ethernet) && (myDevice.ethernet = new Ethernet());
                (!myDevice.ethernet.adapters) && (myDevice.ethernet.adapters = new Array<Adapter>());
                (!myDevice.ethernet.adapters[0]) && (myDevice.ethernet.adapters.push(new Adapter()));
                (!myDevice.ethernet.adapters[0].iPv4) && (myDevice.ethernet.adapters[0].iPv4 = new IPAddr());

                //MM - DHCP switch
                (!myDevice.ethernet.adapters[0].iPv4.addresses) && (myDevice.ethernet.adapters[0].iPv4.addresses = new Array<Addresses>());
                (!myDevice.ethernet.adapters[0].iPv4.addresses[0]) && (myDevice.ethernet.adapters[0].iPv4.addresses.push(new Addresses()));

                (!myDevice.ethernet.adapters[0].iPv4.staticAddresses) && (myDevice.ethernet.adapters[0].iPv4.staticAddresses = new Array<Addresses>());
                (!myDevice.ethernet.adapters[0].iPv4.staticAddresses[0]) && (myDevice.ethernet.adapters[0].iPv4.staticAddresses.push(new Addresses()));
                break;

            case "ethernet.adapters.0.iPv4.dnsServers":
            case "ethernet.adapters.0.iPv4.staticDns":
                thisOperation.operation = OperationEnum.SetFull;
                thisOperation.targetObject = "Ethernet";
                (!myDevice.ethernet) && (myDevice.ethernet = new Ethernet());
                (!myDevice.ethernet.adapters) && (myDevice.ethernet.adapters = new Array<Adapter>());
                (!myDevice.ethernet.adapters[0]) && (myDevice.ethernet.adapters.push(new Adapter()));
                (!myDevice.ethernet.adapters[0].iPv4) && (myDevice.ethernet.adapters[0].iPv4 = new IPAddr());

                if (!this.modelTypesForCFA()) {
                    //First check is DHCP 1 is enabled...
                    if (this.getNIC1DHCPEnabled()) {
                        //Set staticDNS array to null
                        (!myDevice.ethernet.adapters[0].iPv4.staticDns) && (myDevice.ethernet.adapters[0].iPv4.staticDns = null);
                        //Init the dnsServers array
                        (!myDevice.ethernet.adapters[0].iPv4.dnsServers) && (myDevice.ethernet.adapters[0].iPv4.dnsServers = new Array<string>());
                    }
                    else {
                        //Set dnsServers array to null
                        (!myDevice.ethernet.adapters[0].iPv4.dnsServers) && (myDevice.ethernet.adapters[0].iPv4.dnsServers = null);
                        //Init the staticDNS array
                        (!myDevice.ethernet.adapters[0].iPv4.staticDns) && (myDevice.ethernet.adapters[0].iPv4.staticDns = new Array<string>());
                    }
                } else {

                    (!myDevice.ethernet.adapters[0].iPv4.staticDns) && (myDevice.ethernet.adapters[0].iPv4.dnsServers = null);
                    (!myDevice.ethernet.adapters[0].iPv4.staticDns) && (myDevice.ethernet.adapters[0].iPv4.staticDns = new Array<string>());
                }

                break;

            case "ethernet.adapters.0.iPv4.dnsServers.0":
            case "ethernet.adapters.0.iPv4.staticDns.0":
                thisOperation.operation = OperationEnum.SetFull;
                thisOperation.targetObject = "Ethernet";
                (!myDevice.ethernet) && (myDevice.ethernet = new Ethernet());
                (!myDevice.ethernet.adapters) && (myDevice.ethernet.adapters = new Array<Adapter>());
                (!myDevice.ethernet.adapters[0]) && (myDevice.ethernet.adapters.push(new Adapter()));
                (!myDevice.ethernet.adapters[0].iPv4) && (myDevice.ethernet.adapters[0].iPv4 = new IPAddr());

                (!myDevice.ethernet.adapters[0].iPv4.dnsServers) && (myDevice.ethernet.adapters[0].iPv4.dnsServers = new Array<string>());
                (!myDevice.ethernet.adapters[0].iPv4.dnsServers[0]) && (myDevice.ethernet.adapters[0].iPv4.dnsServers.push(""));

                if (!this.modelTypesForCFA()) {
                    //First check is DHCP 1 is enabled...
                    if (this.getNIC1DHCPEnabled()) {
                        //Set staticDNS array to null
                        (!myDevice.ethernet.adapters[0].iPv4.staticDns) && (myDevice.ethernet.adapters[0].iPv4.staticDns = null);
                        //Init the dnsServers array
                        (!myDevice.ethernet.adapters[0].iPv4.dnsServers) && (myDevice.ethernet.adapters[0].iPv4.dnsServers = new Array<string>());
                        (!myDevice.ethernet.adapters[0].iPv4.dnsServers[0]) && (myDevice.ethernet.adapters[0].iPv4.dnsServers.push(""));
                    }
                    else {
                        //Set dnsServers array to null
                        (!myDevice.ethernet.adapters[0].iPv4.dnsServers) && (myDevice.ethernet.adapters[0].iPv4.dnsServers = null);
                        //Init the staticDNS array
                        (!myDevice.ethernet.adapters[0].iPv4.staticDns) && (myDevice.ethernet.adapters[0].iPv4.staticDns = new Array<string>());
                        (!myDevice.ethernet.adapters[0].iPv4.staticDns[0]) && (myDevice.ethernet.adapters[0].iPv4.staticDns.push(""));
                    }
                } else {
                    (!myDevice.ethernet.adapters[0].iPv4.staticDns) && (myDevice.ethernet.adapters[0].iPv4.dnsServers = null);
                    (!myDevice.ethernet.adapters[0].iPv4.staticDns) && (myDevice.ethernet.adapters[0].iPv4.staticDns = new Array<string>());
                    (!myDevice.ethernet.adapters[0].iPv4.staticDns[0]) && (myDevice.ethernet.adapters[0].iPv4.staticDns.push(""));

                }

                break;

            case "ethernet.adapters.0.iPv4.dnsServers.1":
            case "ethernet.adapters.0.iPv4.staticDns.1":
                thisOperation.operation = OperationEnum.SetFull;
                thisOperation.targetObject = "Ethernet";
                (!myDevice.ethernet) && (myDevice.ethernet = new Ethernet());
                (!myDevice.ethernet.adapters) && (myDevice.ethernet.adapters = new Array<Adapter>());
                (!myDevice.ethernet.adapters[0]) && (myDevice.ethernet.adapters.push(new Adapter()));
                (!myDevice.ethernet.adapters[0].iPv4) && (myDevice.ethernet.adapters[0].iPv4 = new IPAddr());

                if (!this.modelTypesForCFA()) {

                    //First check is DHCP 1 is enabled...
                    if (this.getNIC1DHCPEnabled()) {
                        //Set staticDNS array to null
                        (!myDevice.ethernet.adapters[0].iPv4.staticDns) && (myDevice.ethernet.adapters[0].iPv4.staticDns = null);
                        //Init the dnsServers array
                        (!myDevice.ethernet.adapters[0].iPv4.dnsServers) && (myDevice.ethernet.adapters[0].iPv4.dnsServers = new Array<string>());
                        (!myDevice.ethernet.adapters[0].iPv4.dnsServers[1]) && (myDevice.ethernet.adapters[0].iPv4.dnsServers.push(""));
                    }
                    else {
                        //Set dnsServers array to null
                        (!myDevice.ethernet.adapters[0].iPv4.dnsServers) && (myDevice.ethernet.adapters[0].iPv4.dnsServers = null);
                        //Init the staticDNS array
                        (!myDevice.ethernet.adapters[0].iPv4.staticDns) && (myDevice.ethernet.adapters[0].iPv4.staticDns = new Array<string>());
                        (!myDevice.ethernet.adapters[0].iPv4.staticDns[1]) && (myDevice.ethernet.adapters[0].iPv4.staticDns.push(""));
                    }
                } else {
                    (!myDevice.ethernet.adapters[0].iPv4.dnsServers) && (myDevice.ethernet.adapters[0].iPv4.dnsServers = null);
                    //Init the staticDNS array
                    (!myDevice.ethernet.adapters[0].iPv4.staticDns) && (myDevice.ethernet.adapters[0].iPv4.staticDns = new Array<string>());
                    (!myDevice.ethernet.adapters[0].iPv4.staticDns[1]) && (myDevice.ethernet.adapters[0].iPv4.staticDns.push(""));
                }

                break;

            case "ethernet.adapters.1":
                thisOperation.operation = OperationEnum.SetFull;
                thisOperation.targetObject = "Ethernet";
                (!myDevice.ethernet) && (myDevice.ethernet = new Ethernet());
                (!myDevice.ethernet.adapters) && (myDevice.ethernet.adapters = new Array<Adapter>());
                (!myDevice.ethernet.adapters[1]) && (myDevice.ethernet.adapters.push(new Adapter()));
                break;
            case "ethernet.adapters.1.iPv4":
                thisOperation.operation = OperationEnum.SetFull;
                thisOperation.targetObject = "Ethernet";
                (!myDevice.ethernet) && (myDevice.ethernet = new Ethernet());
                (!myDevice.ethernet.adapters) && (myDevice.ethernet.adapters = new Array<Adapter>());
                (!myDevice.ethernet.adapters[1]) && (myDevice.ethernet.adapters.push(new Adapter()));
                (!myDevice.ethernet.adapters[1].iPv4) && (myDevice.ethernet.adapters[1].iPv4 = new IPAddr());
                break;

            case "ethernet.adapters.1.iPv4.addresses":
            case "ethernet.adapters.1.iPv4.staticAddresses":
                thisOperation.operation = OperationEnum.SetFull;
                thisOperation.targetObject = "Ethernet";
                (!myDevice.ethernet) && (myDevice.ethernet = new Ethernet());
                (!myDevice.ethernet.adapters) && (myDevice.ethernet.adapters = new Array<Adapter>());
                (!myDevice.ethernet.adapters[1]) && (myDevice.ethernet.adapters.push(new Adapter()));
                (!myDevice.ethernet.adapters[1].iPv4) && (myDevice.ethernet.adapters[1].iPv4 = new IPAddr());

                //MM - DHCP switch
                (!myDevice.ethernet.adapters[1].iPv4.addresses) && (myDevice.ethernet.adapters[1].iPv4.addresses = new Array<Addresses>());
                (!myDevice.ethernet.adapters[1].iPv4.staticAddresses) && (myDevice.ethernet.adapters[1].iPv4.staticAddresses = new Array<Addresses>());

                break;
            case "ethernet.adapters.1.iPv4.addresses.0":
            case "ethernet.adapters.1.iPv4.staticAddresses.0":
                thisOperation.operation = OperationEnum.SetFull;
                thisOperation.targetObject = "Ethernet";
                (!myDevice.ethernet) && (myDevice.ethernet = new Ethernet());
                (!myDevice.ethernet.adapters) && (myDevice.ethernet.adapters = new Array<Adapter>());
                (!myDevice.ethernet.adapters[1]) && (myDevice.ethernet.adapters.push(new Adapter()));
                (!myDevice.ethernet.adapters[1].iPv4) && (myDevice.ethernet.adapters[1].iPv4 = new IPAddr());

                //MM - DHCP switch
                (!myDevice.ethernet.adapters[1].iPv4.addresses) && (myDevice.ethernet.adapters[1].iPv4.addresses = new Array<Addresses>());
                (!myDevice.ethernet.adapters[1].iPv4.addresses[0]) && (myDevice.ethernet.adapters[1].iPv4.addresses.push(new Addresses()));

                (!myDevice.ethernet.adapters[1].iPv4.staticAddresses) && (myDevice.ethernet.adapters[1].iPv4.staticAddresses = new Array<Addresses>());
                (!myDevice.ethernet.adapters[1].iPv4.staticAddresses[0]) && (myDevice.ethernet.adapters[1].iPv4.staticAddresses.push(new Addresses()));

                break;

            case "ethernet.adapters.1.iPv4.dnsServers":
            case "ethernet.adapters.1.iPv4.staticDns":
                thisOperation.operation = OperationEnum.SetFull;
                thisOperation.targetObject = "Ethernet";
                (!myDevice.ethernet) && (myDevice.ethernet = new Ethernet());
                (!myDevice.ethernet.adapters) && (myDevice.ethernet.adapters = new Array<Adapter>());
                (!myDevice.ethernet.adapters[1]) && (myDevice.ethernet.adapters.push(new Adapter()));
                (!myDevice.ethernet.adapters[1].iPv4) && (myDevice.ethernet.adapters[1].iPv4 = new IPAddr());
                if (!this.modelTypesForCFA()) {

                    //First check is DHCP 2 is enabled...
                    if (this.getNIC2DHCPEnabled()) {
                        //Set staticDNS array to null
                        (!myDevice.ethernet.adapters[1].iPv4.staticDns) && (myDevice.ethernet.adapters[1].iPv4.staticDns = null);
                        //Init the dnsServers array
                        (!myDevice.ethernet.adapters[1].iPv4.dnsServers) && (myDevice.ethernet.adapters[1].iPv4.dnsServers = new Array<string>());
                    }
                    else {
                        //Set dnsServers array to null
                        (!myDevice.ethernet.adapters[1].iPv4.dnsServers) && (myDevice.ethernet.adapters[1].iPv4.dnsServers = null);
                        //Init the staticDNS array
                        (!myDevice.ethernet.adapters[1].iPv4.staticDns) && (myDevice.ethernet.adapters[1].iPv4.staticDns = new Array<string>());
                    }
                } else {
                    (!myDevice.ethernet.adapters[1].iPv4.dnsServers) && (myDevice.ethernet.adapters[1].iPv4.dnsServers = null);
                    (!myDevice.ethernet.adapters[1].iPv4.staticDns) && (myDevice.ethernet.adapters[1].iPv4.staticDns = new Array<string>());
                }

                break;

            case "ethernet.adapters.1.iPv4.dnsServers.0":
            case "ethernet.adapters.1.iPv4.staticDns.0":
                thisOperation.operation = OperationEnum.SetFull;
                thisOperation.targetObject = "Ethernet";
                (!myDevice.ethernet) && (myDevice.ethernet = new Ethernet());
                (!myDevice.ethernet.adapters) && (myDevice.ethernet.adapters = new Array<Adapter>());
                (!myDevice.ethernet.adapters[1]) && (myDevice.ethernet.adapters.push(new Adapter()));
                (!myDevice.ethernet.adapters[1].iPv4) && (myDevice.ethernet.adapters[1].iPv4 = new IPAddr());

                if (!this.modelTypesForCFA()) {
                    //First check is DHCP 2 is enabled...
                    if (this.getNIC2DHCPEnabled()) {
                        //Set staticDNS array to null
                        (!myDevice.ethernet.adapters[1].iPv4.staticDns) && (myDevice.ethernet.adapters[1].iPv4.staticDns = null);
                        //Init the dnsServers array
                        (!myDevice.ethernet.adapters[1].iPv4.dnsServers) && (myDevice.ethernet.adapters[1].iPv4.dnsServers = new Array<string>());
                        (!myDevice.ethernet.adapters[1].iPv4.dnsServers[0]) && (myDevice.ethernet.adapters[1].iPv4.dnsServers.push(""));
                    }
                    else {
                        //Set dnsServers array to null
                        (!myDevice.ethernet.adapters[1].iPv4.dnsServers) && (myDevice.ethernet.adapters[1].iPv4.dnsServers = null);
                        //Init the staticDNS array
                        (!myDevice.ethernet.adapters[1].iPv4.staticDns) && (myDevice.ethernet.adapters[1].iPv4.staticDns = new Array<string>());
                        (!myDevice.ethernet.adapters[1].iPv4.staticDns[0]) && (myDevice.ethernet.adapters[1].iPv4.staticDns.push(""));
                    }
                } else {

                    (!myDevice.ethernet.adapters[1].iPv4.dnsServers) && (myDevice.ethernet.adapters[1].iPv4.dnsServers = null);
                    (!myDevice.ethernet.adapters[1].iPv4.staticDns) && (myDevice.ethernet.adapters[1].iPv4.staticDns = new Array<string>());
                    (!myDevice.ethernet.adapters[1].iPv4.staticDns[0]) && (myDevice.ethernet.adapters[1].iPv4.staticDns.push(""));
                }
                break;

            case "ethernet.adapters.1.iPv4.dnsServers.1":
            case "ethernet.adapters.1.iPv4.staticDns.1":
                thisOperation.operation = OperationEnum.SetFull;
                thisOperation.targetObject = "Ethernet";
                (!myDevice.ethernet) && (myDevice.ethernet = new Ethernet());
                (!myDevice.ethernet.adapters) && (myDevice.ethernet.adapters = new Array<Adapter>());
                (!myDevice.ethernet.adapters[1]) && (myDevice.ethernet.adapters.push(new Adapter()));
                (!myDevice.ethernet.adapters[1].iPv4) && (myDevice.ethernet.adapters[1].iPv4 = new IPAddr());

                if (!this.modelTypesForCFA()) {
                    //First check is DHCP 2 is enabled...
                    if (this.getNIC2DHCPEnabled()) {
                        //Set staticDNS array to null
                        (!myDevice.ethernet.adapters[1].iPv4.staticDns) && (myDevice.ethernet.adapters[1].iPv4.staticDns = null);
                        //Init the dnsServers array
                        (!myDevice.ethernet.adapters[1].iPv4.dnsServers) && (myDevice.ethernet.adapters[1].iPv4.dnsServers = new Array<string>());
                        (!myDevice.ethernet.adapters[1].iPv4.dnsServers[1]) && (myDevice.ethernet.adapters[1].iPv4.dnsServers.push(""));
                    }
                    else {
                        //Set dnsServers array to null
                        (!myDevice.ethernet.adapters[1].iPv4.dnsServers) && (myDevice.ethernet.adapters[1].iPv4.dnsServers = null);
                        //Init the staticDNS array
                        (!myDevice.ethernet.adapters[1].iPv4.staticDns) && (myDevice.ethernet.adapters[1].iPv4.staticDns = new Array<string>());
                        (!myDevice.ethernet.adapters[1].iPv4.staticDns[1]) && (myDevice.ethernet.adapters[1].iPv4.staticDns.push(""));
                    }
                } else {

                    (!myDevice.ethernet.adapters[1].iPv4.dnsServers) && (myDevice.ethernet.adapters[1].iPv4.dnsServers = null);
                    (!myDevice.ethernet.adapters[1].iPv4.staticDns) && (myDevice.ethernet.adapters[1].iPv4.staticDns = new Array<string>());
                    (!myDevice.ethernet.adapters[1].iPv4.staticDns[1]) && (myDevice.ethernet.adapters[1].iPv4.staticDns.push(""));
                }
                break;

            case "licenseRegistry":

                thisOperation.targetObject = "LicenseRegistry";
                (!myDevice.licenseRegistry) && (myDevice.licenseRegistry = new LicenseRegistry());

                break;



            case "autoUpdateMaster":

                thisOperation.targetObject = "AutoUpdateMaster";
                (!myDevice.autoUpdateMaster) && (myDevice.autoUpdateMaster = new AutoUpdateMaster());


                break;

            case "autoUpdateMaster.deviceCredentials":

                thisOperation.targetObject = "AutoUpdateMaster";
                (!myDevice.autoUpdateMaster) && (myDevice.autoUpdateMaster = new AutoUpdateMaster());
                (!myDevice.autoUpdateMaster.deviceCredentials) && (myDevice.autoUpdateMaster.deviceCredentials = new Credentials());

                break;


            case "fusionCloud":
                thisOperation.targetObject = "FusionCloud";
                (!myDevice.fusionCloud) && (myDevice.fusionCloud = new FusionCloud());


                break;


            case "sip":
                thisOperation.targetObject = "Sip";
                (!myDevice.sip) && (myDevice.sip = new FWSIP());


                break;


            case "systemClock":
                thisOperation.targetObject = "SystemClock";
                (!myDevice.systemClock) && (myDevice.systemClock = new SystemClock());


                break;

            case "systemClock.sntp":
                thisOperation.targetObject = "SystemClock";
                (!myDevice.systemClock) && (myDevice.systemClock = new SystemClock());
                (!myDevice.systemClock.sntp) && (myDevice.systemClock.sntp = new Sntp());

                break;

            case "systemVersions":

                thisOperation.targetObject = "SystemVersions";
                (!myDevice.systemVersions) && (myDevice.systemVersions = new SystemVersions());


                break;

            case "airMedia":

                thisOperation.targetObject = "AirMedia";
                (!myDevice.airMedia) && (myDevice.airMedia = new AirMedia());


                break;

            case "airMedia.connectionDisplayOptions":

                thisOperation.targetObject = "AirMedia";
                (!myDevice.airMedia) && (myDevice.airMedia = new AirMedia());
                (!myDevice.airMedia.connectionDisplayOptions) && (myDevice.airMedia.connectionDisplayOptions = new ConnectionDisplayOptions());

                break;

            case "audioVideoInputOutput":

                thisOperation.targetObject = "AudioVideoInputOutput";
                (!myDevice.audioVideoInputOutput) && (myDevice.audioVideoInputOutput = new AudioVideoInputOutput());

                break;

            case "audioVideoInputOutput.outputs.0.ports.0.downstreamEdid":

                thisOperation.targetObject = "AudioVideoInputOutput";
                (!myDevice.audioVideoInputOutput) && (myDevice.audioVideoInputOutput = new AudioVideoInputOutput());
                (!myDevice.audioVideoInputOutput.outputs) && (myDevice.audioVideoInputOutput.outputs = new Array<InputOutput>());
                (!myDevice.audioVideoInputOutput.outputs[0]) && (myDevice.audioVideoInputOutput.outputs.push(new InputOutput()));
                (!myDevice.audioVideoInputOutput.outputs[0].ports) && (myDevice.audioVideoInputOutput.outputs[0].ports = new Array<Port>());
                (!myDevice.audioVideoInputOutput.outputs[0].ports[0]) && (myDevice.audioVideoInputOutput.outputs[0].ports.push(new Port()));
                (!myDevice.audioVideoInputOutput.outputs[0].ports[0].downstreamEdid) && (myDevice.audioVideoInputOutput.outputs[0].ports[0].downstreamEdid = new DownstreamEdid());
                break;

            case "audioVideoInputOutput.outputs.0.ports.0.hdmi":

                thisOperation.targetObject = "AudioVideoInputOutput";
                (!myDevice.audioVideoInputOutput) && (myDevice.audioVideoInputOutput = new AudioVideoInputOutput());
                (!myDevice.audioVideoInputOutput.outputs) && (myDevice.audioVideoInputOutput.outputs = new Array<InputOutput>());
                (!myDevice.audioVideoInputOutput.outputs[0]) && (myDevice.audioVideoInputOutput.outputs.push(new InputOutput()));
                (!myDevice.audioVideoInputOutput.outputs[0].ports) && (myDevice.audioVideoInputOutput.outputs[0].ports = new Array<Port>());
                (!myDevice.audioVideoInputOutput.outputs[0].ports[0]) && (myDevice.audioVideoInputOutput.outputs[0].ports.push(new Port()));
                (!myDevice.audioVideoInputOutput.outputs[0].ports[0].hdmi) && (myDevice.audioVideoInputOutput.outputs[0].ports[0].hdmi = new Hdmi());

                break;
            case "audioVideoInputOutput.outputs.0.ports.0":

                thisOperation.targetObject = "AudioVideoInputOutput";
                (!myDevice.audioVideoInputOutput) && (myDevice.audioVideoInputOutput = new AudioVideoInputOutput());
                (!myDevice.audioVideoInputOutput.outputs) && (myDevice.audioVideoInputOutput.outputs = new Array<InputOutput>());
                (!myDevice.audioVideoInputOutput.outputs[0]) && (myDevice.audioVideoInputOutput.outputs.push(new InputOutput()));
                (!myDevice.audioVideoInputOutput.outputs[0].ports) && (myDevice.audioVideoInputOutput.outputs[0].ports = new Array<Port>());
                (!myDevice.audioVideoInputOutput.outputs[0].ports[0]) && (myDevice.audioVideoInputOutput.outputs[0].ports.push(new Port()));

                break;

            case "audioVideoInputOutput.inputs.0.ports.0.hdmi":

                thisOperation.targetObject = "AudioVideoInputOutput";
                (!myDevice.audioVideoInputOutput) && (myDevice.audioVideoInputOutput = new AudioVideoInputOutput());
                (!myDevice.audioVideoInputOutput.inputs) && (myDevice.audioVideoInputOutput.inputs = new Array<InputOutput>());
                (!myDevice.audioVideoInputOutput.inputs[0]) && (myDevice.audioVideoInputOutput.inputs.push(new InputOutput()));
                (!myDevice.audioVideoInputOutput.inputs[0].ports) && (myDevice.audioVideoInputOutput.inputs[0].ports = new Array<Port>());
                (!myDevice.audioVideoInputOutput.inputs[0].ports[0]) && (myDevice.audioVideoInputOutput.inputs[0].ports.push(new Port()));
                (!myDevice.audioVideoInputOutput.inputs[0].ports[0].hdmi) && (myDevice.audioVideoInputOutput.inputs[0].ports[0].hdmi = new Hdmi());

                break;

            case "app":

                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());


                break;

            case "app.config":


                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());
                (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());


                break;

            case "app.config.audioDevices":

                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());
                (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());
                (!myDevice.app.config.audioDevices) && (myDevice.app.config.audioDevices = new AudioDevices());


                break;

            case "app.config.audioDevices.bluetooth":

                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());
                (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());
                (!myDevice.app.config.audioDevices) && (myDevice.app.config.audioDevices = new AudioDevices());
                (!myDevice.app.config.audioDevices.bluetooth) && (myDevice.app.config.audioDevices.bluetooth = new Bluetooth());


                break;

            case "app.config.audioDevices.uSB":

                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());
                (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());
                (!myDevice.app.config.audioDevices) && (myDevice.app.config.audioDevices = new AudioDevices());
                (!myDevice.app.config.audioDevices.uSB) && (myDevice.app.config.audioDevices.uSB = new USB());


                break;

            case "app.config.audioDevices.sIP":

                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());
                (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());
                (!myDevice.app.config.audioDevices) && (myDevice.app.config.audioDevices = new AudioDevices());
                (!myDevice.app.config.audioDevices.sIP) && (myDevice.app.config.audioDevices.sIP = new SIP());


                break;

            case "app.config.audioDevices.sIP.speedKeys":

                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());
                (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());
                (!myDevice.app.config.audioDevices) && (myDevice.app.config.audioDevices = new AudioDevices());
                (!myDevice.app.config.audioDevices.sIP) && (myDevice.app.config.audioDevices.sIP = new SIP());

                (!myDevice.app.config.audioDevices.sIP.speedKeys) && (myDevice.app.config.audioDevices.sIP.speedKeys = new Array<Speedkey>());

                break;
            case "app.config.audioDevices.sIP.speedKeys.0":

                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());
                (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());
                (!myDevice.app.config.audioDevices) && (myDevice.app.config.audioDevices = new AudioDevices());
                (!myDevice.app.config.audioDevices.sIP) && (myDevice.app.config.audioDevices.sIP = new SIP());

                (!myDevice.app.config.audioDevices.sIP.speedKeys) && (myDevice.app.config.audioDevices.sIP.speedKeys = new Array<Speedkey>());

                (!myDevice.app.config.audioDevices.sIP.speedKeys[0]) &&
                    (myDevice.app.config.audioDevices.sIP.speedKeys.push(new Speedkey()));

                break;
            case "app.config.audioDevices.sIP.speedKeys.1":

                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());
                (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());
                (!myDevice.app.config.audioDevices) && (myDevice.app.config.audioDevices = new AudioDevices());
                (!myDevice.app.config.audioDevices.sIP) && (myDevice.app.config.audioDevices.sIP = new SIP());

                (!myDevice.app.config.audioDevices.sIP.speedKeys) && (myDevice.app.config.audioDevices.sIP.speedKeys = new Array<Speedkey>());

                (!myDevice.app.config.audioDevices.sIP.speedKeys[0]) &&
                    (myDevice.app.config.audioDevices.sIP.speedKeys.push(new Speedkey()));

                (!myDevice.app.config.audioDevices.sIP.speedKeys[1]) &&
                    (myDevice.app.config.audioDevices.sIP.speedKeys.push(new Speedkey()));

                break;
            case "app.config.audioDevices.sIP.speedKeys.2":

                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());
                (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());
                (!myDevice.app.config.audioDevices) && (myDevice.app.config.audioDevices = new AudioDevices());
                (!myDevice.app.config.audioDevices.sIP) && (myDevice.app.config.audioDevices.sIP = new SIP());

                (!myDevice.app.config.audioDevices.sIP.speedKeys) && (myDevice.app.config.audioDevices.sIP.speedKeys = new Array<Speedkey>());

                (!myDevice.app.config.audioDevices.sIP.speedKeys[0]) &&
                    (myDevice.app.config.audioDevices.sIP.speedKeys.push(new Speedkey()));

                (!myDevice.app.config.audioDevices.sIP.speedKeys[1]) &&
                    (myDevice.app.config.audioDevices.sIP.speedKeys.push(new Speedkey()));

                (!myDevice.app.config.audioDevices.sIP.speedKeys[2]) &&
                    (myDevice.app.config.audioDevices.sIP.speedKeys.push(new Speedkey()));

                break;
            case "app.config.audioDevices.sIP.speedKeys.3":


                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());
                (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());
                (!myDevice.app.config.audioDevices) && (myDevice.app.config.audioDevices = new AudioDevices());
                (!myDevice.app.config.audioDevices.sIP) && (myDevice.app.config.audioDevices.sIP = new SIP());

                (!myDevice.app.config.audioDevices.sIP.speedKeys) && (myDevice.app.config.audioDevices.sIP.speedKeys = new Array<Speedkey>());

                (!myDevice.app.config.audioDevices.sIP.speedKeys[0]) &&
                    (myDevice.app.config.audioDevices.sIP.speedKeys.push(new Speedkey()));

                (!myDevice.app.config.audioDevices.sIP.speedKeys[1]) &&
                    (myDevice.app.config.audioDevices.sIP.speedKeys.push(new Speedkey()));

                (!myDevice.app.config.audioDevices.sIP.speedKeys[2]) &&
                    (myDevice.app.config.audioDevices.sIP.speedKeys.push(new Speedkey()));

                (!myDevice.app.config.audioDevices.sIP.speedKeys[3]) &&
                    (myDevice.app.config.audioDevices.sIP.speedKeys.push(new Speedkey()));


                break;
            case "app.config.audioDevices.sIP.speedKeys.4":

                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());
                (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());
                (!myDevice.app.config.audioDevices) && (myDevice.app.config.audioDevices = new AudioDevices());
                (!myDevice.app.config.audioDevices.sIP) && (myDevice.app.config.audioDevices.sIP = new SIP());

                (!myDevice.app.config.audioDevices.sIP.speedKeys) && (myDevice.app.config.audioDevices.sIP.speedKeys = new Array<Speedkey>());


                (!myDevice.app.config.audioDevices.sIP.speedKeys[0]) &&
                    (myDevice.app.config.audioDevices.sIP.speedKeys.push(new Speedkey()));

                (!myDevice.app.config.audioDevices.sIP.speedKeys[1]) &&
                    (myDevice.app.config.audioDevices.sIP.speedKeys.push(new Speedkey()));

                (!myDevice.app.config.audioDevices.sIP.speedKeys[2]) &&
                    (myDevice.app.config.audioDevices.sIP.speedKeys.push(new Speedkey()));

                (!myDevice.app.config.audioDevices.sIP.speedKeys[3]) &&
                    (myDevice.app.config.audioDevices.sIP.speedKeys.push(new Speedkey()));

                (!myDevice.app.config.audioDevices.sIP.speedKeys[4]) &&
                    (myDevice.app.config.audioDevices.sIP.speedKeys.push(new Speedkey()));


                break;

            case "app.config.audioDevices.sFB":

                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());
                (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());
                (!myDevice.app.config.audioDevices) && (myDevice.app.config.audioDevices = new AudioDevices());
                (!myDevice.app.config.audioDevices.sFB) && (myDevice.app.config.audioDevices.sFB = new SFB());


                break;

            case "app.config.audioDevices.sFB.presets":

                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());
                (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());
                (!myDevice.app.config.audioDevices) && (myDevice.app.config.audioDevices = new AudioDevices());
                (!myDevice.app.config.audioDevices.sFB) && (myDevice.app.config.audioDevices.sFB = new SFB());

                (!myDevice.app.config.audioDevices.sFB.presets) && (myDevice.app.config.audioDevices.sFB.presets = new Array<Preset>());

                break;


            case "app.config.audioDevices.sFB.presets.0":

                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());
                (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());
                (!myDevice.app.config.audioDevices) && (myDevice.app.config.audioDevices = new AudioDevices());
                (!myDevice.app.config.audioDevices.sFB) && (myDevice.app.config.audioDevices.sFB = new SFB());

                (!myDevice.app.config.audioDevices.sFB.presets) && (myDevice.app.config.audioDevices.sFB.presets = new Array<Preset>());

                (!myDevice.app.config.audioDevices.sFB.presets[0]) &&
                    (myDevice.app.config.audioDevices.sFB.presets.push(new Preset()));

                break;

            case "app.config.audioDevices.sFB.presets.1":

                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());
                (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());
                (!myDevice.app.config.audioDevices) && (myDevice.app.config.audioDevices = new AudioDevices());
                (!myDevice.app.config.audioDevices.sFB) && (myDevice.app.config.audioDevices.sFB = new SFB());

                (!myDevice.app.config.audioDevices.sFB.presets) && (myDevice.app.config.audioDevices.sFB.presets = new Array<Preset>());

                (!myDevice.app.config.audioDevices.sFB.presets[0]) &&
                    (myDevice.app.config.audioDevices.sFB.presets.push(new Preset()));

                (!myDevice.app.config.audioDevices.sFB.presets[1]) &&
                    (myDevice.app.config.audioDevices.sFB.presets.push(new Preset()));

                break;

            case "app.config.audioDevices.sFB.presets.2":

                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());
                (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());
                (!myDevice.app.config.audioDevices) && (myDevice.app.config.audioDevices = new AudioDevices());
                (!myDevice.app.config.audioDevices.sFB) && (myDevice.app.config.audioDevices.sFB = new SFB());

                (!myDevice.app.config.audioDevices.sFB.presets) && (myDevice.app.config.audioDevices.sFB.presets = new Array<Preset>());

                (!myDevice.app.config.audioDevices.sFB.presets[0]) &&
                    (myDevice.app.config.audioDevices.sFB.presets.push(new Preset()));

                (!myDevice.app.config.audioDevices.sFB.presets[1]) &&
                    (myDevice.app.config.audioDevices.sFB.presets.push(new Preset()));

                (!myDevice.app.config.audioDevices.sFB.presets[2]) &&
                    (myDevice.app.config.audioDevices.sFB.presets.push(new Preset()));


                break;

            case "app.config.audioDevices.sFB.presets.3":

                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());
                (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());
                (!myDevice.app.config.audioDevices) && (myDevice.app.config.audioDevices = new AudioDevices());
                (!myDevice.app.config.audioDevices.sFB) && (myDevice.app.config.audioDevices.sFB = new SFB());

                (!myDevice.app.config.audioDevices.sFB.presets) && (myDevice.app.config.audioDevices.sFB.presets = new Array<Preset>());

                (!myDevice.app.config.audioDevices.sFB.presets[0]) &&
                    (myDevice.app.config.audioDevices.sFB.presets.push(new Preset()));

                (!myDevice.app.config.audioDevices.sFB.presets[1]) &&
                    (myDevice.app.config.audioDevices.sFB.presets.push(new Preset()));

                (!myDevice.app.config.audioDevices.sFB.presets[2]) &&
                    (myDevice.app.config.audioDevices.sFB.presets.push(new Preset()));

                (!myDevice.app.config.audioDevices.sFB.presets[3]) &&
                    (myDevice.app.config.audioDevices.sFB.presets.push(new Preset()));

                break;

            case "app.config.audioDevices.sFB.presets.4":

                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());
                (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());
                (!myDevice.app.config.audioDevices) && (myDevice.app.config.audioDevices = new AudioDevices());
                (!myDevice.app.config.audioDevices.sFB) && (myDevice.app.config.audioDevices.sFB = new SFB());

                (!myDevice.app.config.audioDevices.sFB.presets) && (myDevice.app.config.audioDevices.sFB.presets = new Array<Preset>());

                (!myDevice.app.config.audioDevices.sFB.presets[0]) &&
                    (myDevice.app.config.audioDevices.sFB.presets.push(new Preset()));

                (!myDevice.app.config.audioDevices.sFB.presets[1]) &&
                    (myDevice.app.config.audioDevices.sFB.presets.push(new Preset()));

                (!myDevice.app.config.audioDevices.sFB.presets[2]) &&
                    (myDevice.app.config.audioDevices.sFB.presets.push(new Preset()));

                (!myDevice.app.config.audioDevices.sFB.presets[3]) &&
                    (myDevice.app.config.audioDevices.sFB.presets.push(new Preset()));

                (!myDevice.app.config.audioDevices.sFB.presets[4]) &&
                    (myDevice.app.config.audioDevices.sFB.presets.push(new Preset()));


                break;

            case "app.config.audioDevices.sIP.regexs":

                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());
                (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());
                (!myDevice.app.config.audioDevices) && (myDevice.app.config.audioDevices = new AudioDevices());
                (!myDevice.app.config.audioDevices.sIP) && (myDevice.app.config.audioDevices.sIP = new SIP());

                (!myDevice.app.config.audioDevices.sIP.regexs) && (myDevice.app.config.audioDevices.sIP.regexs = new Array<string>());


                break;

            case "app.config.fusionSetup":

                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());
                (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());
                (!myDevice.app.config.fusionSetup) && (myDevice.app.config.fusionSetup = new FusionSetup());


                break;

            case "app.config.general":

                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());
                (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());
                (!myDevice.app.config.general) && (myDevice.app.config.general = new General());


                break;

            case "app.config.runTimeSettings":


                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());
                (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());
                (!myDevice.app.config.runTimeSettings) && (myDevice.app.config.runTimeSettings = new RunTimeSettings());


                break;

            case "app.config.runTimeSettings.backgrounds":


                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());
                (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());
                (!myDevice.app.config.runTimeSettings) && (myDevice.app.config.runTimeSettings = new RunTimeSettings());


                (!myDevice.app.config.runTimeSettings.backgrounds) && (myDevice.app.config.runTimeSettings.backgrounds = new Background());


                break;

            case "app.config.runTimeSettings.backgrounds.customBackgroundList":



                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());
                (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());
                (!myDevice.app.config.runTimeSettings) && (myDevice.app.config.runTimeSettings = new RunTimeSettings());
                (!myDevice.app.config.runTimeSettings.backgrounds) && (myDevice.app.config.runTimeSettings.backgrounds = new Background());
                (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList) && (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList = new Array<CustomBackground>());



                break;

            case "app.config.runTimeSettings.backgrounds.customBackgroundList.0":
            case "app.config.runTimeSettings.backgrounds.customBackgroundList.1":
            case "app.config.runTimeSettings.backgrounds.customBackgroundList.2":
            case "app.config.runTimeSettings.backgrounds.customBackgroundList.3":
            case "app.config.runTimeSettings.backgrounds.customBackgroundList.4":
            case "app.config.runTimeSettings.backgrounds.customBackgroundList.5":
            case "app.config.runTimeSettings.backgrounds.customBackgroundList.6":
            case "app.config.runTimeSettings.backgrounds.customBackgroundList.7":
            case "app.config.runTimeSettings.backgrounds.customBackgroundList.8":
            case "app.config.runTimeSettings.backgrounds.customBackgroundList.9":
            case "app.config.runTimeSettings.backgrounds.customBackgroundList.10":
            case "app.config.runTimeSettings.backgrounds.customBackgroundList.11":
            case "app.config.runTimeSettings.backgrounds.customBackgroundList.12":
            case "app.config.runTimeSettings.backgrounds.customBackgroundList.13":
            case "app.config.runTimeSettings.backgrounds.customBackgroundList.14":

                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());
                (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());
                (!myDevice.app.config.runTimeSettings) && (myDevice.app.config.runTimeSettings = new RunTimeSettings());
                (!myDevice.app.config.runTimeSettings.backgrounds) && (myDevice.app.config.runTimeSettings.backgrounds = new Background());
                (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList) && (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList = new Array<CustomBackground>());


                (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[0]) &&
                    (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));
                (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[1]) &&
                    (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));
                (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[2]) &&
                    (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));
                (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[3]) &&
                    (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));
                (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[4]) &&
                    (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));
                (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[5]) &&
                    (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));
                (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[6]) &&
                    (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));
                (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[7]) &&
                    (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));
                (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[8]) &&
                    (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));
                (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[9]) &&
                    (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));
                (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[10]) &&
                    (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));
                (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[11]) &&
                    (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));
                (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[12]) &&
                    (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));
                (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[13]) &&
                    (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));
                (!myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList[14]) &&
                    (myDevice.app.config.runTimeSettings.backgrounds.customBackgroundList.push(new CustomBackground()));

                break;


            case "app.config.runTimeSettings.logo":

                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());
                (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());
                (!myDevice.app.config.runTimeSettings) && (myDevice.app.config.runTimeSettings = new RunTimeSettings());

                (!myDevice.app.config.runTimeSettings.logo) && (myDevice.app.config.runTimeSettings.logo = new Logo());


                break;

            case "app.config.scheduling":

                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());
                (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());

                (!myDevice.app.config.scheduling) && (myDevice.app.config.scheduling = new Scheduling());


                break;

            case "app.config.timeOptions":

                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());
                (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());

                (!myDevice.app.config.timeOptions) && (myDevice.app.config.timeOptions = new TimeOptions());


                break;

            case "app.config.videoDisplay":


                thisOperation.operation = OperationEnum.SetFull;//MM - Bug 142416 - Must be SET FULL in outstanding updates
                thisOperation.targetObject = "App";
                (!myDevice.app) && (myDevice.app = new App());
                (!myDevice.app.config) && (myDevice.app.config = new AVFSettings());

                (!myDevice.app.config.videoDisplay) && (myDevice.app.config.videoDisplay = new VideoDisplay());

                break;

            //Zoom Room Mode
            case "thirdPartyApplications":
                thisOperation.operation = OperationEnum.SetFull;
                thisOperation.targetObject = "ThirdPartyApplications";
                (!myDevice.thirdPartyApplications) && (myDevice.thirdPartyApplications = new ThirdPartyApplications());
                break;

            case "thirdPartyApplications.zoomRoom":
                thisOperation.operation = OperationEnum.SetFull;
                thisOperation.targetObject = "ThirdPartyApplications";
                (!myDevice.thirdPartyApplications) && (myDevice.thirdPartyApplications = new ThirdPartyApplications());
                (!myDevice.thirdPartyApplications.zoomRoom) && (myDevice.thirdPartyApplications.zoomRoom = new ZoomRoom());
                break;


            //3 series device object model preparation
            case "cloudSettings":
                thisOperation.operation = OperationEnum.SetFull;
                thisOperation.targetObject = "CloudSettings";
                (!myDevice.cloudSettings) && (myDevice.cloudSettings = new CloudSettings());
                break;

            case "cloudSettings.fusionCloud":
                thisOperation.operation = OperationEnum.SetFull;
                thisOperation.targetObject = "CloudSettings";
                (!myDevice.cloudSettings) && (myDevice.cloudSettings = new CloudSettings());
                (!myDevice.cloudSettings.fusionCloud) && (myDevice.cloudSettings.fusionCloud = new FusionCloud2());
                break;



        }

        //Check if target of operation is already added
        let foundOperation: DeviceOperation = this.allOperations.find(operation => {
            return operation.targetObject === thisOperation.targetObject;
        });
        if (!foundOperation) {
            this.allOperations.push(thisOperation);
        }


    }

    //-----------------------------------------------
    // isSettingsAvailable()
    //-----------------------------------------------
    protected isSettingsAvailable() {

        let bAvailable: boolean = false;
        if (this.device && this.device.app) {
            if (this.device.app.config) {
                bAvailable = true;
            }
        }


        return bAvailable;

    }

    //-----------------------------------------------
    // resolveDeviceValue
    //-----------------------------------------------
    protected resolveDeviceValue(parent: any, settingID: string, settingHardPath: string, settingSoftPath: string, defaultValue: any, controlType?: DeviceControlType) {

        let value: any;
        try {

            if (objectPath.has(parent, settingHardPath)) {


                switch (settingID) {

                    case "fusion-ip-id":
                    case "video-display-driver-ip-id":

                        value = objectPath.get(parent, settingHardPath);
                        if (value === 0) {
                            if (settingID === "fusion-ip-id") {
                                value = 3;
                            }
                            else if (settingID === "video-display-driver-ip-id") {
                                value = 4;
                            }
                        }

                        break;
                    case "video-display-model":
                    case "video-display-driver-control":

                        if (this.device) {//MM - Only do this special logic on the device level.. Group Settings is able to persist this.
                            value = defaultValue;

                            //Determine the model and control based on driverID.. instead of just giving me the model and control like any other setting. :(


                            let driverSetting: DeviceControlModel = new DeviceControlModel();
                            driverSetting.id = "video-display-driver-id";
                            let driverPath = this.getModelParams(driverSetting).hardPath;
                            let driverId = objectPath.get(parent, driverPath);


                            for (let model in this.displayDrivers) {

                                for (let control in this.displayDrivers[model]) {

                                    if (this.displayDrivers[model][control].driverId === driverId) {

                                        if (settingID === "video-display-model") {
                                            value = model;
                                        }
                                        else if (settingID === "video-display-driver-control") {
                                            value = control;
                                        }

                                    }

                                }

                            }
                        }
                        else {
                            value = objectPath.get(parent, settingHardPath);
                        }



                        break;

                    case "time-setting":

                        value = objectPath.get(parent, settingHardPath);

                        break;

                    case "airmedia-assigned-ethernet-port":
                    case "assigned-sip-ethernet-port":



                        if (objectPath.get(parent, settingHardPath).length > 0) {

                            //MM - Bug 124200 - 'Both' is no longer supported
                            //if (objectPath.get(parent, settingHardPath).length === 1) {

                            if (objectPath.get(parent, settingHardPath + ".0") === "eth0") {
                                value = true;//"main";
                            }
                            else if (objectPath.get(parent, settingHardPath + ".0") === "eth1") {
                                value = false;//"aux";
                            }

                            //}
                            //else if (objectPath.get(parent, settingHardPath).length === 2) {
                            //    value = "both";
                            //}

                        }

                        break;

                    default: //Default behavior to resolve value

                        value = objectPath.get(parent, settingHardPath);

                        break;

                }



            }
            else {
                value = defaultValue;
            }

            // MM -  Bug 134268 - Ensure every password is handled the same way in the UI... show 4 stars.. because the device is not returning passwords in a uniform way.
            if (controlType) {
                if (controlType === DeviceControlType.Password) {
                    value = defaultValue;
                }
            }

            if (settingID === "zoomRoom-enabled") {
                this.zoomRoomInitValue = value;
            }

        }
        catch (e) {
            console.log("Error -->resolveDeviceValue: " + settingID + " path: " + settingHardPath);
        }
        return value;

    }



    //-----------------------------------------------
    // buildDeviceOperation
    //-----------------------------------------------
    protected buildDeviceOperations(): Array<DeviceOperation> {

        let all: Array<DeviceOperation> = new Array<DeviceOperation>();
        let op: DeviceOperation;

        op = new DeviceOperation();
        op.operation = OperationEnum.SetPartial;
        op.targetObject = "AirMedia";
        all.push(op);

        op = new DeviceOperation();
        op.operation = OperationEnum.SetPartial;
        op.targetObject = "AudioVideoInputOutput";
        all.push(op);

        //op = new DeviceOperation();
        //op.operation = OperationEnum.SetPartial;
        //op.targetObject = "Authentication";
        //all.push(op);

        //op = new DeviceOperation();
        //op.operation = OperationEnum.SetPartial;
        //op.targetObject = "AutoUpdateMaster";
        //all.push(op);

        op = new DeviceOperation();
        op.operation = OperationEnum.SetPartial;
        op.targetObject = "App";
        all.push(op);

        op = new DeviceOperation();
        op.operation = OperationEnum.SetPartial;
        op.targetObject = "Ethernet";
        all.push(op);

        //op = new DeviceOperation();
        //op.operation = OperationEnum.SetPartial;
        //op.targetObject = "LicenseRegistry";
        //all.push(op);

        op = new DeviceOperation();
        op.operation = OperationEnum.SetPartial;
        op.targetObject = "FusionCloud";
        all.push(op);

        op = new DeviceOperation();
        op.operation = OperationEnum.SetPartial;
        op.targetObject = "SIP";
        all.push(op);

        //op = new DeviceOperation();
        //op.operation = OperationEnum.SetPartial;
        //op.targetObject = "Snmp";
        //all.push(op);

        op = new DeviceOperation();
        op.operation = OperationEnum.SetPartial;
        op.targetObject = "SystemClock";
        all.push(op);

        //op = new DeviceOperation();
        //op.operation = OperationEnum.SetPartial;
        //op.targetObject = "UserInterfaceConfig";
        //all.push(op);

        op = new DeviceOperation();
        op.operation = OperationEnum.SetPartial;
        op.targetObject = "ThirdPartyApplications";
        all.push(op);

        op = new DeviceOperation();
        op.operation = OperationEnum.SetPartial;
        op.targetObject = "CloudSettings";
        all.push(op);

        return all;

    }

    //----------------------------------------------------------
    //getControlValue
    //----------------------------------------------------------
    protected getControlValue(control: DeviceFormControlModel) {

        var value: any = control.value;
        var controls: any = this.formSettings.controls;
        if (control.model.type === DeviceControlType.RadioButton) {

            for (let item of control.model.options) {

                if (controls[item.id] && controls[item.id].value) {
                    value = item.value;
                    break;
                }

            }

        }

        return value;
    }

    //----------------------------------------------------------
    //toFormGroup
    //----------------------------------------------------------
    protected toFormGroup(categories) {
        let formGroup: any = {};
        this.formSettings = null;

        try {
            if (categories && categories.length > 0) {
                categories.forEach(categoryTop => {


                    if (categoryTop && categoryTop.visible && categoryTop.settings && categoryTop.settings.length > 0) {

                        categoryTop.settings.forEach(setting => {

                            if (setting) {
                                //Create form control
                                formGroup[setting.id] = this.createFormControl(setting);
                                formGroup[setting.id + '-select'] = this.createFormControlSelector(setting);

                                if (setting.type === DeviceControlType.RadioButton) {
                                    for (var item of setting.options) {
                                        formGroup[item.id] = new DeviceFormControlModel({ value: setting.value, disabled: false } || '');
                                    }
                                }

                            }
                        });



                    }

                    if (categoryTop && categoryTop.visible && categoryTop.categories && categoryTop.categories.length > 0) {
                        categoryTop.categories.forEach(category2nd => {

                            if (category2nd && category2nd.visible && category2nd.settings && category2nd.settings.length > 0) {
                                category2nd.settings.forEach(setting => {

                                    if (setting) {
                                        //Create form control
                                        formGroup[setting.id] = this.createFormControl(setting);
                                        formGroup[setting.id + '-select'] = this.createFormControlSelector(setting);

                                        if (setting.type === DeviceControlType.RadioButton) {
                                            for (var item of setting.options) {
                                                formGroup[item.id] = new DeviceFormControlModel({ value: setting.value, disabled: false } || '');
                                            }
                                        }

                                    }

                                });
                            }

                            if (category2nd && category2nd.visible && category2nd.categories && category2nd.categories.length > 0) {
                                category2nd.categories.forEach(category3rd => {


                                    if (category3rd && category3rd.visible && category3rd.settings && category3rd.settings.length > 0) {
                                        category3rd.settings.forEach(setting => {

                                            if (setting) {
                                                //Create form control
                                                formGroup[setting.id] = this.createFormControl(setting);
                                                formGroup[setting.id + '-select'] = this.createFormControlSelector(setting);

                                                if (setting.type === DeviceControlType.RadioButton) {
                                                    for (var item of setting.options) {
                                                        formGroup[item.id] = new DeviceFormControlModel({ value: setting.value, disabled: false } || '');
                                                    }
                                                }

                                            }

                                        });
                                    }

                                    if (category3rd && category3rd.visible && category3rd.grouping && category3rd.grouping.length > 0) {
                                        category3rd.grouping.forEach(setting => {


                                            if (setting) {
                                                //Create form control
                                                formGroup[setting.id] = this.createFormControl(setting);
                                                if (setting.type === DeviceControlType.RadioButton) {
                                                    for (var item of setting.options) {
                                                        formGroup[item.id] = new DeviceFormControlModel({ value: setting.value, disabled: false } || '');
                                                    }
                                                }

                                            }

                                        });
                                    }

                                });
                            }

                        });

                    }
                });
            }
        }
        catch (e) {
            console.log("Error-->toFormGroup()");
        }


        return new FormGroup(formGroup);
    }
    //----------------------------------------------------------
    //makeFormPristine
    //----------------------------------------------------------
    protected makeFormPristine() {


        let controls: any = this.formSettings.controls;
        for (var index in controls) {
            controls[index].markAsPristine();
        }

    }

    //-----------------------------------------------
    // resetFlags
    //-----------------------------------------------
    protected resetFlags() {

        this.invalidFields = "";
        this.toggleAll = false;
        this.dirty = false;
        this.touched = false;
        this.changedNIC = false;
        this.changedVideoDisplay = false;
        this.changedBackground = false;
        this.changedFusionCloud = false;//MM - Bug 147575 - Added check for Fusion Cloud

        //YH 3/10/2017 Bug 118831
        this.touched = false;
        this.saved = true;

    }


    //----------------------------------------------------------
    //isSettingDisabled()
    //----------------------------------------------------------
    protected isSettingDisabled(model: DeviceControlModel) {

        let bFlag: boolean = false;

        if (model) {
            if (!model.apply || model.inherited) {
                bFlag = true;
            }
        }
        return bFlag;

    }


    //-----------------------------------------------
    // initAccordians
    //-----------------------------------------------
    protected initAccordians() {

        if (this.viewModel && this.viewModel.length > 0) {

            let firstRun: boolean = false;
            let categories = this.viewModel;

            if (this.tabState.length !== this.viewModel.length) {
                firstRun = true;
                this.tabState = new Array<boolean>();//Reset Tab state
            }

            // Set tab selection states
            for (let index = 0; index < categories.length; index++) {

                let showCategory = this.showCategory(categories[index]);

                //Remove any category which is not visible.. and selected is true
                if (showCategory === false) {
                    categories.splice(index, 1);//Remove invisible item from category

                    if (categories[index]) {// MM Bug 141269 - However, if the removed category is the LAST in the list, ignore the following steps
                      categories[index].selected = true;//Set next category to selected
                      this.tabState[index] = true;
                      categories[index].selected = true;
                    }
                    else if (categories[index - 1]) {//MM Bug 141269 - Set PREVIOUS category to selected
                      this.tabState[index] = false; // MM Bug 141269 - First correct the tab state..since this category was sliced out
                      categories[index - 1].selected = true;
                      this.tabState[index - 1] = true;
                      categories[index - 1].selected = true;
                    }
                    if (!categories || categories.length === 0) {
                      this.bNoSettings = true;
                    }
                }
                else {
                    if (firstRun) {
                        this.tabState[index] = categories[index].selected;
                    }
                    else {
                        categories[index].selected = this.tabState[index];
                    }

                }

            }



        }


    }


    //----------------------------------------------------------
    //createFormControl
    //----------------------------------------------------------
    protected createFormControl(setting: DeviceControlModel) {

        var control: any;

        control = new DeviceFormControlModel({ value: setting.value, disabled: this.isSettingDisabled(setting) } || '');
        control.model = setting;

        if (setting.apply && setting.visible && !setting.inherited) {
            this.setCrestronValidation(control);
        }
        else {
            control.clearValidators();

        }



        return control;

    }

    //----------------------------------------------------------
    //createFormControl
    //----------------------------------------------------------
    protected createFormControlSelector(setting: DeviceControlModel) {

        var control: DeviceFormControlModel;

        if (this.device) {
            control = new DeviceFormControlModel({ value: setting.apply } || '');
        }


        return control;

    }
    //-----------------------------------------------
    // showCategory
    //-----------------------------------------------
    protected showCategory(category: DeviceCategoryModel): boolean {
        let show: boolean = false;

        //Search the child categories and settings to determine whether to show.
        for (let index = 0; index < category.categories.length; index++) {

            show = category.categories[index].visible;

        }
        for (let index = 0; index < category.settings.length; index++) {

            show = category.settings[index].visible;

        }

        return show;

    }

    //-----------------------------------------------
    // refreshData
    //-----------------------------------------------
    protected refreshData(pushNotification: boolean = false) {


        this.initAccordians();
        this.resetFlags();



    }
    //-----------------------------------------------
    // mapDeviceSettings
    //-----------------------------------------------
    protected mapDeviceSettings(pendingDevice: Device) {


        try {


            //SIP --------------------------
            this.setValueOnModel("enable-sip", pendingDevice);
            this.setValueOnModel("sip-server-ip-address", pendingDevice);
            this.setValueOnModel("sip-port", pendingDevice);
            this.setValueOnModel("sip-server-username", pendingDevice);
            this.setValueOnModel("sip-server-password", pendingDevice);
            this.setValueOnModel("sip-server-realm", pendingDevice);
            this.setValueOnModel("assigned-sip-ethernet-port", pendingDevice);
            this.setValueOnModel("sip-proxy-server", pendingDevice);
            this.setValueOnModel("sip-local-extension", pendingDevice);
            this.setValueOnModel("sip-transport-type", pendingDevice);
            this.setValueOnModel("sip-display-extension", pendingDevice);//Appspace
            
            this.setValueOnModel("speedkey-1-enabled", pendingDevice);
            this.setValueOnModel("speedkey-1-name", pendingDevice);
            this.setValueOnModel("speedkey-1-number", pendingDevice);

            this.setValueOnModel("speedkey-2-enabled", pendingDevice);
            this.setValueOnModel("speedkey-2-name", pendingDevice);
            this.setValueOnModel("speedkey-2-number", pendingDevice);

            this.setValueOnModel("speedkey-3-enabled", pendingDevice);
            this.setValueOnModel("speedkey-3-name", pendingDevice);
            this.setValueOnModel("speedkey-3-number", pendingDevice);

            this.setValueOnModel("speedkey-4-enabled", pendingDevice);
            this.setValueOnModel("speedkey-4-name", pendingDevice);
            this.setValueOnModel("speedkey-4-number", pendingDevice);

            ///SfB settings
            this.setValueOnModel("sfb-enabled", pendingDevice);
            this.setValueOnModel("sfb-username", pendingDevice);
            this.setValueOnModel("sfb-password", pendingDevice);
            this.setValueOnModel("sfb-sip-address", pendingDevice);
            this.setValueOnModel("sfb-internal-server-name", pendingDevice);
            this.setValueOnModel("sfb-external-server-name", pendingDevice);
            this.setValueOnModel("sfb-displayextension", pendingDevice);//Appspace
            this.setValueOnModel("sfb-proxy-type", pendingDevice);
            this.setValueOnModel("sfb-proxy-username", pendingDevice);
            this.setValueOnModel("sfb-proxy-password", pendingDevice);

            this.setValueOnModel("sfb-preset-1-enabled", pendingDevice);
            this.setValueOnModel("sfb-preset-1-name", pendingDevice);
            this.setValueOnModel("sfb-preset-1-number", pendingDevice);
            this.setValueOnModel("sfb-preset-1-type", pendingDevice);

            this.setValueOnModel("sfb-preset-2-enabled", pendingDevice);
            this.setValueOnModel("sfb-preset-2-name", pendingDevice);
            this.setValueOnModel("sfb-preset-2-number", pendingDevice);
            this.setValueOnModel("sfb-preset-2-type", pendingDevice);

            this.setValueOnModel("sfb-preset-3-enabled", pendingDevice);
            this.setValueOnModel("sfb-preset-3-name", pendingDevice);
            this.setValueOnModel("sfb-preset-3-number", pendingDevice);
            this.setValueOnModel("sfb-preset-3-type", pendingDevice);

            this.setValueOnModel("sfb-preset-4-enabled", pendingDevice);
            this.setValueOnModel("sfb-preset-4-name", pendingDevice);
            this.setValueOnModel("sfb-preset-4-number", pendingDevice);
            this.setValueOnModel("sfb-preset-4-type", pendingDevice);


            ////Time Options --------------------------
            this.setValueOnModel("custom-time-server", pendingDevice);
            //this.setValueOnModel("time-setting", pendingDevice);
            this.setValueOnModel("timezone", pendingDevice);
            this.setValueOnModel("sntp-enabled", pendingDevice);

            //General --------------------------
            this.setValueOnModel("language", pendingDevice);
            this.setValueOnModel("friendly-system-name", pendingDevice);



            //Time Options --------------------------
            this.setValueOnModel("date-format", pendingDevice);
            this.setValueOnModel("time-format", pendingDevice);


            //FusionSetup --------------------------
            this.setValueOnModel("fusion-enabled", pendingDevice);
            // this.setValueOnModel("fusion-enable-tls", pendingDevice);// MM - 4/27/17 as per Brian
            this.setValueOnModel("fusion-ip-id", pendingDevice);
            this.setValueOnModel("fusion-room-name", pendingDevice);
            this.setValueOnModel("fusion-cloud-url-enabled", pendingDevice);
            this.setValueOnModel("fusion-cloud-url", pendingDevice);


            //AudioVideo --------------------------
            this.setValueOnModel("display-power-control", pendingDevice);

            //AirMedia --------------------------
            this.setValueOnModel("enable-airmedia", pendingDevice);//Appspace
            this.setValueOnModel("airmedia-show-login-code", pendingDevice);//CFA
            this.setValueOnModel("airmedia-login-code-mode", pendingDevice);
            this.setValueOnModel("airmedia-login-code", pendingDevice);
            this.setValueOnModel("airmedia-assigned-ethernet-port", pendingDevice);

            //AirMedia Connection display options
            this.setValueOnModel("airmedia-show-connection-info", pendingDevice);//CFA
            this.setValueOnModel("airmedia-connection-info-mode", pendingDevice);//CFA
            this.setValueOnModel("airmedia-custom-string", pendingDevice);//CFA

            //AirMedia  Connection display options - Not Visible
            this.setValueOnModel("airmedia-display-ipaddress", pendingDevice);
            this.setValueOnModel("airmedia-display-hostname", pendingDevice);
            this.setValueOnModel("airmedia-display-domainname", pendingDevice);
            this.setValueOnModel("airmedia-display-custom-string", pendingDevice);


            //AudioDevices.USB --------------------------
            this.setValueOnModel("usb-enabled", pendingDevice);

            //AudioDevices.Bluetooth --------------------------
            this.setValueOnModel("bluetooth-enabled", pendingDevice);
            this.setValueOnModel("friendly-bluetooth-name", pendingDevice);
            // this.setValueOnModel("bluetooth-enable-dial-hangup-buttons", pendingDevice); //MM - Removed 3/21/17 as per Mike Troup


            //AudioConference --------------------------
            // this.setValueOnModel("key-click", pendingDevice); //MM - Removed 3/21/17 as per Mike Troup
            this.setValueOnModel("audio-dialing-regex-1", pendingDevice);
            this.setValueOnModel("audio-dialing-regex-2", pendingDevice);
            this.setValueOnModel("audio-dialing-regex-3", pendingDevice);


            //Scheduling ------------------------------------
            this.setValueOnModel("enable-scheduling", pendingDevice);
            this.setValueOnModel("source", pendingDevice);
            this.setValueOnModel("outlook-resource-address", pendingDevice);
            this.setValueOnModel("outlook-web-access-url", pendingDevice);
            this.setValueOnModel("outlook-domain-name", pendingDevice);
            this.setValueOnModel("outlook-user-email-address", pendingDevice);
            this.setValueOnModel("outlook-password", pendingDevice);






            //RunTimeSettings --------------------------
            this.setValueOnModel("hide-meeting-subject", pendingDevice);
            this.setValueOnModel("enable-show-broadcast-message", pendingDevice);//Appspace
            this.setValueOnModel("enable-touch-screen-backgrounds", pendingDevice);//Appspace
            this.setValueOnModel("touch-screen-background-selection", pendingDevice);//Appspace
            this.setValueOnModel("show-calendar-clock-overlay", pendingDevice);//Appspace

            this.setValueOnModel("next-meeting-information-minutes-before-meeting-start", pendingDevice);
            this.setValueOnModel("hide-wired-cable-connection", pendingDevice);
            this.setValueOnModel("cable-connection-details", pendingDevice);
            this.setValueOnModel("interval-between-backgrounds", pendingDevice);

            this.setValueOnModel("enable-custom-logo-graphic", pendingDevice);
            this.setValueOnModel("custom-logo-graphic-url", pendingDevice);

            this.setValueOnModel("enable-custom-backgrounds", pendingDevice);
            //this.setValueOnModel("custom-background-url-1-enabled", pendingDevice);
            //this.setValueOnModel("custom-background-url-1-name", pendingDevice);
            this.setValueOnModel("custom-background-url-1", pendingDevice);

            //this.setValueOnModel("custom-background-url-2-enabled", pendingDevice);
            // this.setValueOnModel("custom-background-url-2-name", pendingDevice);
            this.setValueOnModel("custom-background-url-2", pendingDevice);

            // this.setValueOnModel("custom-background-url-3-enabled", pendingDevice);
            // this.setValueOnModel("custom-background-url-3-name", pendingDevice);
            this.setValueOnModel("custom-background-url-3", pendingDevice);

            // this.setValueOnModel("custom-background-url-4-enabled", pendingDevice);
            // this.setValueOnModel("custom-background-url-4-name", pendingDevice);
            this.setValueOnModel("custom-background-url-4", pendingDevice);

            // this.setValueOnModel("custom-background-url-5-enabled", pendingDevice);
            // this.setValueOnModel("custom-background-url-5-name", pendingDevice);
            this.setValueOnModel("custom-background-url-5", pendingDevice);

            // this.setValueOnModel("custom-background-url-6-enabled", pendingDevice);
            //  this.setValueOnModel("custom-background-url-6-name", pendingDevice);
            this.setValueOnModel("custom-background-url-6", pendingDevice);

            // this.setValueOnModel("custom-background-url-7-enabled", pendingDevice);
            // this.setValueOnModel("custom-background-url-7-name", pendingDevice);
            this.setValueOnModel("custom-background-url-7", pendingDevice);

            //this.setValueOnModel("custom-background-url-8-enabled", pendingDevice);
            // this.setValueOnModel("custom-background-url-8-name", pendingDevice);
            this.setValueOnModel("custom-background-url-8", pendingDevice);

            // this.setValueOnModel("custom-background-url-9-enabled", pendingDevice);
            // this.setValueOnModel("custom-background-url-9-name", pendingDevice);
            this.setValueOnModel("custom-background-url-9", pendingDevice);

            // this.setValueOnModel("custom-background-url-10-enabled", pendingDevice);
            //this.setValueOnModel("custom-background-url-10-name", pendingDevice);
            this.setValueOnModel("custom-background-url-10", pendingDevice);

            //this.setValueOnModel("custom-background-url-11-enabled", pendingDevice);
            //this.setValueOnModel("custom-background-url-11-name", pendingDevice);
            this.setValueOnModel("custom-background-url-11", pendingDevice);

            // this.setValueOnModel("custom-background-url-12-enabled", pendingDevice);
            //this.setValueOnModel("custom-background-url-12-name", pendingDevice);
            this.setValueOnModel("custom-background-url-12", pendingDevice);

            //this.setValueOnModel("custom-background-url-13-enabled", pendingDevice);
            //this.setValueOnModel("custom-background-url-13-name", pendingDevice);
            this.setValueOnModel("custom-background-url-13", pendingDevice);

            // this.setValueOnModel("custom-background-url-14-enabled", pendingDevice);
            //this.setValueOnModel("custom-background-url-14-name", pendingDevice);
            this.setValueOnModel("custom-background-url-14", pendingDevice);

            // this.setValueOnModel("custom-background-url-15-enabled", pendingDevice);
            //this.setValueOnModel("custom-background-url-15-name", pendingDevice);
            this.setValueOnModel("custom-background-url-15", pendingDevice);


            this.setValueOnModel("time-remaining-message-duration-seconds", pendingDevice);
            this.setValueOnModel("time-remaining-message-starts-minutes", pendingDevice);

            //Video Display
            this.setValueOnModel("video-display-name", pendingDevice);

            this.setValueOnModel("video-display-model", pendingDevice);
            this.setValueOnModel("video-display-driver-control", pendingDevice);
            this.setValueOnModel("video-display-default-input", pendingDevice);

            this.setValueOnModel("video-display-driver-baud-rate", pendingDevice);
            this.setValueOnModel("video-display-driver-ip-id", pendingDevice);
            this.setValueOnModel("video-display-driver-channel", pendingDevice);
            this.setValueOnModel("video-display-driver-ip-address", pendingDevice);
            this.setValueOnModel("video-display-driver-port", pendingDevice);
            this.setValueOnModel("video-display-driver-id", pendingDevice);

            this.setValueOnModel("hide-meeting-organizer", pendingDevice);
            this.setValueOnModel("emergency-broadcast-timeout", pendingDevice);
            this.setValueOnModel("non-emergency-broadcast-timeout", pendingDevice);
            this.setValueOnModel("enable-call-notification", pendingDevice);
            this.setValueOnModel("call-notification-timeout", pendingDevice);
            this.setValueOnModel("enable-hdmi-input", pendingDevice);//Appspace


            //MM - Removed again as per product manager 3/10/17
            //this.setValueOnModel("device-password", pendingDevice);
            //this.setValueOnModel("device-password-confirm", pendingDevice);



            //MM - Removed 3/16/17 as per Mike Troup
            this.setValueOnModel("hdmi-output-name", pendingDevice);
            // this.setValueOnModel("hdmi-output-disabled", pendingDevice);
            // this.setValueOnModel("hdmi-output-resolution", pendingDevice);
            // this.setValueOnModel("hdmi-input-hdcp-support-enabled", pendingDevice);


            //Ethernet --------------------------
            this.setValueOnModel("host-name", pendingDevice);
            this.setValueOnModel("domain", pendingDevice);



            this.setValueOnModel("nic-1-dhcp", pendingDevice);
            this.setValueOnModel("nic-1-ip-address", pendingDevice);
            this.setValueOnModel("nic-1-subnet-mask", pendingDevice);
            this.setValueOnModel("nic-1-def-router", pendingDevice);
            this.setValueOnModel("nic-1-primary-dns", pendingDevice);
            this.setValueOnModel("nic-1-secondary-dns", pendingDevice);


            this.setValueOnModel("nic-2-dhcp", pendingDevice);
            this.setValueOnModel("nic-2-ip-address", pendingDevice);
            this.setValueOnModel("nic-2-subnet-mask", pendingDevice);
            this.setValueOnModel("nic-2-def-router", pendingDevice);
            this.setValueOnModel("nic-2-primary-dns", pendingDevice);
            this.setValueOnModel("nic-2-secondary-dns", pendingDevice);


            //Zoom Room Mode
            this.setValueOnModel("zoomRoom-enabled", pendingDevice);
            
            //Appspace
            this.setValueOnModel("appspace-enabled", pendingDevice);
            this.setValueOnModel("appspace-account-location", pendingDevice);
            this.setValueOnModel("appspace-server-url", pendingDevice);
            this.setValueOnModel("appspace-isSignageInStandbyEnabled", pendingDevice);
            this.setValueOnModel("appspace-isSignageAsBackgroundEnabled", pendingDevice);

            //3 Series device
            this.setValueOnModel("s3-fusion-cloud-url-enabled", pendingDevice);
            this.setValueOnModel("s3-fusion-cloud-url", pendingDevice);


            //CFA
            this.setValueOnModel("background-overlay", pendingDevice);


        }

        catch (e) {

        }


    }
    //-----------------------------------------------
    // getDeviceSettings
    //-----------------------------------------------
    protected getDeviceSettings(): Device {

        let pendingDevice: Device = new Device();
        pendingDevice.deviceInfo = this.device.deviceInfo;
        pendingDevice.id = this.device.id;
        pendingDevice.cid = this.device.cid;
        pendingDevice.accountId = this.device.accountId;
        pendingDevice.groupId = this.device.groupId;
        pendingDevice.lastModified = this.device.lastModified;

        //Reset operations
        this.allOperations = new Array<DeviceOperation>();
        //Get the settings
        this.mapDeviceSettings(pendingDevice);
        //Assign operations
        (!pendingDevice.action) && (pendingDevice.action = new MergeAction());
        (!pendingDevice.action.deliveryState) && (pendingDevice.action.deliveryState = DeliveryStateEnum.Pending);
        (!pendingDevice.action.operations) && (pendingDevice.action.operations = this.allOperations);



        return pendingDevice;

    }




    //-----------------------------------------------
    // getNIC1DHCPEnabled
    //-----------------------------------------------
    protected getNIC1DHCPEnabled(): boolean {

        let bOutput: boolean = false;
        try {

            let controls: any = this.formSettings.controls;

            if (controls["nic-1-dhcp"]) {
                if (this.loading) {

                    //MM - If loading.. get DHCP from sourceSettings..
                    bOutput = (objectPath.has(this.sourceSettings, "ethernet.adapters.0.iPv4.isDhcpEnabled")) ? objectPath.get(this.sourceSettings, "ethernet.adapters.0.iPv4.isDhcpEnabled") : false;

                }
                else {
                    //MM - If saving.. must get DHCP from actual DHCP control..
                    bOutput = controls["nic-1-dhcp"].value;

                }
            }



        }
        catch (e) {
            console.log("Error -->getNIC1DHCPEnabled()");
        }

        return bOutput;


    }

    //-----------------------------------------------
    // getNIC2DHCPEnabled
    //-----------------------------------------------
    protected getNIC2DHCPEnabled(): boolean {

        let bOutput: boolean = false;
        try {

            let controls: any = this.formSettings.controls;

            if (controls["nic-2-dhcp"]) {
                if (this.loading) {

                    //MM - If loading.. get DHCP from sourceSettings..
                    bOutput = (objectPath.has(this.sourceSettings, "ethernet.adapters.1.iPv4.isDhcpEnabled")) ? objectPath.get(this.sourceSettings, "ethernet.adapters.1.iPv4.isDhcpEnabled") : false;

                }
                else {
                    //MM - If saving.. must get DHCP from actual DHCP control..
                    bOutput = controls["nic-2-dhcp"].value;

                }
            }



        }
        catch (e) {
            console.log("Error -->getNIC2DHCPEnabled()");
        }

        return bOutput;


    }


    //-----------------------------------------------
    // getModelParams
    //-----------------------------------------------
    protected getModelParams(setting: DeviceControlModel) {

        let hardPath: string = "";
        let softPath: string = "";
        let defaultValue: any = "";

        let dhcp: boolean;
        let addressesHardString: string;
        let addressesSoftString: string;
        let defaultGatewayHardString: string;
        let defaultGatewaySoftString: string;


        switch (setting.id) {

            case "video-display-driver-id":
                hardPath = "app.config.videoDisplay.driverId";
                softPath = "App.Config.VideoDisplay.DriverId";
                defaultValue = "1D3A3D17-0F53-4f37-AF72-C5EEF9275477";//CEC Controlled Display

                break;
            case "nic-1-def-router":

                //MM - DHCP switch
                dhcp = this.getNIC1DHCPEnabled();
                defaultGatewayHardString = (dhcp) ? "defaultGateway" : "staticDefaultGateway";
                defaultGatewaySoftString = (dhcp) ? "DefaultGateway" : "StaticDefaultGateway";

                hardPath = "ethernet.adapters.0.iPv4." + defaultGatewayHardString;
                softPath = "Ethernet.Adapters[0].IPv4." + defaultGatewaySoftString;
                defaultValue = "";

                break;

            case "nic-1-ip-address":

                //MM - DHCP switch
                dhcp = this.getNIC1DHCPEnabled();
                addressesHardString = (dhcp) ? "addresses" : "staticAddresses";
                addressesSoftString = (dhcp) ? "Addresses" : "StaticAddresses";

                hardPath = "ethernet.adapters.0.iPv4." + addressesHardString + ".0.address";
                softPath = "Ethernet.Adapters[0].IPv4." + addressesSoftString + "[0].Address";

                defaultValue = "";


                break;

            case "nic-1-subnet-mask":

                //MM - DHCP switch
                dhcp = this.getNIC1DHCPEnabled();
                addressesHardString = (dhcp) ? "addresses" : "staticAddresses";
                addressesSoftString = (dhcp) ? "Addresses" : "StaticAddresses";

                hardPath = "ethernet.adapters.0.iPv4." + addressesHardString + ".0.subnetMask";
                softPath = "Ethernet.Adapters[0].IPv4." + addressesSoftString + "[0].SubnetMask";
                defaultValue = "";
                break;


            case "nic-1-primary-dns":
                //SA  If Modle type is mercury then Primary and Secondary static address will pick always from staticDNS
                if (this.modelTypesForCFA()) {
                    addressesHardString = "staticDns";
                    addressesSoftString = "StaticDns";
                } else {

                    //MM - DHCP switch
                    dhcp = this.getNIC1DHCPEnabled();
                    addressesHardString = (dhcp) ? "dnsServers" : "staticDns";
                    addressesSoftString = (dhcp) ? "DnsServers" : "StaticDns";
                }

                hardPath = "ethernet.adapters.0.iPv4." + addressesHardString + ".0";
                softPath = "Ethernet.Adapters[0].IPv4." + addressesSoftString + "[0]";
                defaultValue = "";
                break;

            case "nic-1-secondary-dns":
                //SA  If Modle type is mercury then Primary and Secondary static address will pick always from staticDNS
                if (this.modelTypesForCFA()) {
                    addressesHardString = "staticDns";
                    addressesSoftString = "StaticDns";
                } else {
                    //MM - DHCP switch
                    dhcp = this.getNIC1DHCPEnabled();
                    addressesHardString = (dhcp) ? "dnsServers" : "staticDns";
                    addressesSoftString = (dhcp) ? "DnsServers" : "StaticDns";
                }

                hardPath = "ethernet.adapters.0.iPv4." + addressesHardString + ".1";
                softPath = "Ethernet.Adapters[0].IPv4." + addressesSoftString + "[1]";
                defaultValue = "";
                break;




            case "nic-2-def-router":

                //MM - DHCP switch
            dhcp = (this.modelTypesForCFA()) ? this.getNIC2DHCPEnabled() : this.getNIC1DHCPEnabled();//CFA
                defaultGatewayHardString = (dhcp) ? "defaultGateway" : "staticDefaultGateway";
                defaultGatewaySoftString = (dhcp) ? "DefaultGateway" : "StaticDefaultGateway";

                hardPath = "ethernet.adapters.1.iPv4." + defaultGatewayHardString;
                softPath = "Ethernet.Adapters[1].IPv4." + defaultGatewaySoftString;
                defaultValue = "";

                break;

            case "nic-2-ip-address":

                //MM - DHCP switch
            dhcp = (this.modelTypesForCFA()) ? this.getNIC2DHCPEnabled() : this.getNIC1DHCPEnabled();//CFA
                addressesHardString = (dhcp) ? "addresses" : "staticAddresses";
                addressesSoftString = (dhcp) ? "Addresses" : "StaticAddresses";


                hardPath = "ethernet.adapters.1.iPv4." + addressesHardString + ".0.address";
                softPath = "Ethernet.Adapters[1].IPv4." + addressesSoftString + "[0].Address";
                defaultValue = "";


                break;

            case "nic-2-subnet-mask":

                //MM - DHCP switch
                dhcp = (this.modelTypesForCFA()) ? this.getNIC2DHCPEnabled() : this.getNIC1DHCPEnabled();//CFA
                addressesHardString = (dhcp) ? "addresses" : "staticAddresses";
                addressesSoftString = (dhcp) ? "Addresses" : "StaticAddresses";

                hardPath = "ethernet.adapters.1.iPv4." + addressesHardString + ".0.subnetMask";
                softPath = "Ethernet.Adapters[1].IPv4." + addressesSoftString + "[0].SubnetMask";
                defaultValue = "";
                break;


            case "nic-2-primary-dns":

                if (this.modelTypesForCFA()) {
                    addressesHardString = "staticDns";
                    addressesSoftString = "StaticDns";
                } else {
                    //MM - DHCP switch
                    dhcp = (this.modelTypesForCFA()) ? this.getNIC2DHCPEnabled() : this.getNIC1DHCPEnabled();//CFA
                    addressesHardString = (dhcp) ? "dnsServers" : "staticDns";
                    addressesSoftString = (dhcp) ? "DnsServers" : "StaticDns";
                }

                hardPath = "ethernet.adapters.1.iPv4." + addressesHardString + ".0";
                softPath = "Ethernet.Adapters[1].IPv4." + addressesSoftString + "[0]";
                defaultValue = "";
                break;

            case "nic-2-secondary-dns":

                if (this.modelTypesForCFA()) {
                    addressesHardString = "staticDns";
                    addressesSoftString = "StaticDns";
                } else {
                    //MM - DHCP switch
                    dhcp = (this.modelTypesForCFA()) ? this.getNIC2DHCPEnabled() : this.getNIC1DHCPEnabled();//CFA
                    addressesHardString = (dhcp) ? "dnsServers" : "staticDns";
                    addressesSoftString = (dhcp) ? "DnsServers" : "StaticDns";
                }

                hardPath = "ethernet.adapters.1.iPv4." + addressesHardString + ".1";
                softPath = "Ethernet.Adapters[1].IPv4." + addressesSoftString + "[1]";
                defaultValue = "";
                break;

            default:

                hardPath = setting.hardPath;
                softPath = setting.softPath;
                defaultValue = setting.default;

                break;


        }


        return {
            hardPath: hardPath,
            softPath: softPath,
            defaultValue: defaultValue
        }
    }
    //----------------------------------------------------------
    //fillViewModel
    //----------------------------------------------------------
    protected fillViewModel(categories: DeviceCategoryCollectionModel) {

        let settingID: string;
        this.bNoSettings = true;

        try {
            if (categories && categories.length > 0) {
                categories.forEach(categoryTop => {

                    categoryTop.name = this.translationService.translate(categoryTop.id);



                    //Fill each setting under the Top category
                    if (categoryTop && categoryTop.settings && categoryTop.settings.length > 0) {
                        categoryTop.settings.forEach(setting => {

                            if (setting) {
                                this.fillSettingModel(setting);
                            }
                        });
                    }

                    //Fill each child category under the Top category
                    let bChildSettingsFound: boolean = false;
                    if (categoryTop && categoryTop.categories && categoryTop.categories.length > 0) {

                        categoryTop.categories.forEach(category2nd => {


                            category2nd.name = this.translationService.translate(category2nd.id);


                            //Fill each setting under the 2nd category
                            if (category2nd && category2nd.settings && category2nd.settings.length > 0) {
                                category2nd.settings.forEach(setting => {

                                    if (setting) {
                                        this.fillSettingModel(setting);
                                        //(category2nd.visible || setting.visible) && (bChildSettingsFound = true);
                                    }

                                });
                            }

                            //Fill each child category under the 2nd category
                            if (category2nd && category2nd.categories && category2nd.categories.length > 0) {
                                category2nd.categories.forEach(category3rd => {


                                    category3rd.name = this.translationService.translate(category3rd.id);


                                    //Fill each setting under the 3rd category
                                    if (category3rd.settings && category3rd.settings.length > 0) {
                                        category3rd.settings.forEach(setting => {

                                            if (setting) {
                                                this.fillSettingModel(setting);
                                                //(category3rd.visible || setting.visible) && (bChildSettingsFound = true);
                                            }

                                        });
                                    }

                                    //Fill each child setting under the 3rd category
                                    if (category3rd && category3rd.grouping && category3rd.grouping.length > 0) {
                                        category3rd.grouping.forEach(setting => {


                                            if (setting) {
                                                this.fillSettingModel(setting);
                                                //(setting.visible) && (bChildSettingsFound = true);
                                            }

                                        });
                                    }


                                });
                            }



                        });

                    }


                    if (categoryTop.visible) {
                        this.bNoSettings = false;
                    }



                });
            }


        }
        catch (e) {
            console.log("Error-->fillSettingModel()");
        }

        return categories;
    }



    //-----------------------------------------------
    // getValueFromModel
    //-----------------------------------------------
    protected getValueFromModel(setting: DeviceControlModel, propertyType: DevicePropertyType, controlType?: DeviceControlType) {

        let value: any;
        let model: Device = this.sourceSettings;
        let params: any = {};


        params = this.getModelParams(setting);
        value = this.getValueFromSetting(model, setting.id, setting.visible, propertyType, params.hardPath, params.softPath, params.defaultValue, controlType);


        return value;
    }

    //----------------------------------------------------------
    //fillSettingModel
    //----------------------------------------------------------
    protected fillSettingModel(setting: DeviceControlModel) {

        try {
            setting.label = this.translationService.translate(setting.id);
            setting.apply = this.getValueFromModel(setting, DevicePropertyType.Apply);
            setting.selectable = this.getValueFromModel(setting, DevicePropertyType.Selectable);
            (setting.suffix) && (setting.suffix = this.translationService.translate(setting.suffix));
            (setting.placeholder) && (setting.placeholder = this.translationService.translate(setting.placeholder));

            setting.policy = false;

            switch (setting.id) {

                case "nic-1-dhcp":
                case "nic-2-dhcp":
                    setting.label = this.translationService.translate("dhcp");
                    break;

                case "nic-1-primary-dns"://DUAL NIC special case
                    if (setting.suffix) {
                        setting.label = this.translationService.translate("primary-dns");
                    }

                    break;

                case "nic-1-secondary-dns"://DUAL NIC special case
                    if (setting.suffix) {
                        setting.label = this.translationService.translate("secondary-dns");
                    }

                    break;

                case "enable-scheduling":
                    setting.label = this.translationService.translate("scheduling");
                    break;
                case "language":
                    setting.options = hydUtilService.GetDeviceLanguages();
                    break;
                case "timezone":
                    setting.options = hydUtilService.GetTimeZones();
                    break;
                case "video-display-driver-ip-id":
                case "fusion-ip-id":
                    //MM - Bug 140392 - Below code is commented, as per bug, the larger range of IPIDs is something internal to device.
                    ////let maxval: number = 253;//Default for Mercury
                    ////(this.modelType !== "MERCURY") && (maxval= 65534);
                    setting.options = hydUtilService.GetIPIDs();
                    break;
                case "video-display-model":
                    setting.options = hydUtilService.GetVideoDisplayDrivers();
                    break;
                case "sip-transport-type":
                    setting.options = hydUtilService.GetTransportTypes();
                    break;
            }

            let controlType: any;
            if (hydUtilService.IsNumeric(setting.type)) {
                controlType = setting.type;
            }
            else {
                controlType = DeviceControlType[setting.type];
            }

            switch (controlType) {
                case DeviceControlType.TextBox:
                    setting.type = DeviceControlType.TextBox;
                    break;
                case DeviceControlType.RadioButton:
                    setting.type = DeviceControlType.RadioButton;

                    for (let item of setting.options) {
                        item.label = this.translationService.translate(item.label);
                    }
                    break;
                case DeviceControlType.CheckBox:
                    setting.type = DeviceControlType.CheckBox;
                    break;
                case DeviceControlType.Password:
                    setting.type = DeviceControlType.Password;
                    break;
                case DeviceControlType.ComboBox:
                    setting.type = DeviceControlType.ComboBox;

                    for (let item of setting.options) {
                        item.label = this.translationService.translate(item.label);
                    }
                    break;
                case DeviceControlType.InputSwitch:
                    setting.type = DeviceControlType.InputSwitch;
                    for (let item of setting.options) {
                        item.label = this.translationService.translate(item.label);
                    }
                    break;
                case DeviceControlType.Time:
                    setting.type = DeviceControlType.Time;
                    break;

            }



            setting.value = this.getValueFromModel(setting, DevicePropertyType.GetValue, setting.type);




        }
        catch (e) {
            console.log("Error-->fillSettingModel()");
        }

    }

    //----------------------------------------------------------
    //checkEthernet
    //----------------------------------------------------------
    protected checkEthernet(controls) {


        try {

            let id: string;
            let toggleID: string = "nic-1-dhcp";

            if (controls[toggleID] && controls[toggleID].model) {
                if (controls[toggleID].model.apply === false) {
                    if (!controls[toggleID].model.inherited) controls[toggleID].setValue(true);
                }

                for (var count = 1; count <= 2; count++) {

                    id = "domain";
                    this.evalNIC(id, toggleID);

                    id = "nic-" + count.toString() + "-def-router";
                    this.evalNIC(id, toggleID);

                    id = "nic-" + count.toString() + "-ip-address";
                    this.evalNIC(id, toggleID);

                    id = "nic-" + count.toString() + "-subnet-mask";
                    this.evalNIC(id, toggleID);

                    id = "nic-" + count.toString() + "-primary-dns";
                    this.evalNIC(id, toggleID);

                    id = "nic-" + count.toString() + "-secondary-dns";
                    this.evalNIC(id, toggleID);


                }


            }
        }
        catch (e) {
            console.log("Error-->checkEthernet()");
        }




    }

    //----------------------------------------------------------
    //checkEthernetForCFA
    //----------------------------------------------------------
    protected checkEthernetForCFA(checkNIC1: boolean, checkNIC2: boolean) {

        let controls: any = this.formSettings.controls;

        try {

            let id: string;
            let toggleID: string;
            let count: number;
            let nic1ToggleID: string = "nic-1-dhcp";
            let nic2ToggleID: string = "nic-2-dhcp";
            let nic1DHCP: boolean = false;
            let nic2DHCP: boolean = false;

            if (checkNIC1) {
                count = 1;
                if (controls[nic1ToggleID] && controls[nic1ToggleID].model) {

                    if (controls[nic1ToggleID].model.apply === false) {
                        if (!controls[nic1ToggleID].model.inherited) controls[nic1ToggleID].setValue(true);
                    }

                    id = "nic-" + count.toString() + "-def-router";
                    this.evalNIC(id, nic1ToggleID);

                    id = "nic-" + count.toString() + "-ip-address";
                    this.evalNIC(id, nic1ToggleID);

                    id = "nic-" + count.toString() + "-subnet-mask";
                    this.evalNIC(id, nic1ToggleID);

                    //MM - Bug 139683 - This code needs to be enabled to properly handle DNS Servers..
                    //id = "nic-" + count.toString() + "-primary-dns";
                    //this.evalDNS(id, nic1ToggleID);
                    //id = "nic-" + count.toString() + "-secondary-dns";
                    //this.evalDNS(id, nic1ToggleID);



                }


            }

            if (checkNIC2) {
                count = 2;

                if (controls[nic2ToggleID] && controls[nic2ToggleID].model) {

                    if (controls[nic2ToggleID].model.apply === false) {
                        if (!controls[nic2ToggleID].model.inherited) controls[nic2ToggleID].setValue(true);
                    }

                    id = "domain";
                    this.evalNIC(id, nic2ToggleID);

                    id = "nic-" + count.toString() + "-def-router";
                    this.evalNIC(id, nic2ToggleID);

                    id = "nic-" + count.toString() + "-ip-address";
                    this.evalNIC(id, nic2ToggleID);

                    id = "nic-" + count.toString() + "-subnet-mask";
                    this.evalNIC(id, nic2ToggleID);

                    //MM - Bug 139683 - This code needs to be enabled to properly handle DNS Servers..
                    //id = "nic-" + count.toString() + "-primary-dns";
                    //this.evalDNS(id, nic2ToggleID);
                    //id = "nic-" + count.toString() + "-secondary-dns";
                    //this.evalDNS(id, nic2ToggleID);


                }


            }

            //For Dual NICs, both DHCP have to be inspected to determine if user can edit DOMAIN.
            //If both NICs are supported..
            if (controls[nic1ToggleID] && controls[nic2ToggleID]) {

                nic1DHCP = (controls[nic1ToggleID].value === true);
                nic2DHCP = (controls[nic2ToggleID].value === true);

                if (nic1DHCP === false && nic2DHCP === false) {
                    //If both DHCP are disabled... Enable domain and DNS..
                    id = "domain";
                    controls[id].model.locked = false;
                    if (this.device) {
                        if (!controls[id].model.inherited) {
                            controls[id].model.apply = true;
                            controls[id].enable();
                        }
                    }



                }
                else {

                    //Otherwise... Disable domain
                    id = "domain";
                    controls[id].model.locked = true;
                    controls[id].model.apply = false;
                    controls[id].disable();




                }
            }
            else {
                //If one NIC is supported..
                id = "domain";
                this.evalNIC(id, nic1ToggleID);

            }



        }
        catch (e) {
            console.log("Error-->checkEthernetForCFA()");
        }




    }

    //-----
    //PowerShceduling
    //-----------
    protected checkPowerShceduling() {

        try {
            let controls: any = this.formSettings.controls;
            let toggleMainID: string;
            let toggleChildID: string;
            
            //When Main in unchecked
            toggleMainID = "display-power-control";
            toggleChildID = "sunday-enabled";
            let powercontroloption: string = controls[toggleMainID].value

            if (controls[toggleMainID] && (powercontroloption === "AlwaysOn" || powercontroloption === "OccupancyWithSignage")) {
                let dayControl: any = controls[toggleChildID];
                console.log(powercontroloption);
            }
            else {
                //controls[toggleChildID].model.visible = false;
            }
            


        }
        catch (e) {
            console.log("Error-->checkPowerShceduling()");
        }

    }

    //----------------------
    //checkTouchScreenCustomeBackgrounds
    //----------------------
    protected checkTouchScreenCustomeBackgrounds() {
        try {
            let controls: any = this.formSettings.controls;
            let toggleID: string;
            let touchScreenBackgroundSelection: string;
          

            //When Main in unchecked
            toggleID = "enable-touch-screen-backgrounds";
            touchScreenBackgroundSelection = "touch-screen-background-selection";
           
            if (controls[toggleID].model.apply === false) {

                if (!controls[toggleID].model.inherited) controls[toggleID].setValue(false);

            }
            if (controls[toggleID].value === false) {
                (controls[touchScreenBackgroundSelection]) && (controls[touchScreenBackgroundSelection].model.apply = false);
            }

            this.evalField(toggleID, touchScreenBackgroundSelection);
           
        }
        catch (e) {
            console.log("Error-->checkTouchScreenCustomeBackgrounds()");
        }
    }

    //------------------
    // checkAppspaceServiceURL
    //-------------------
    protected checkAppspace() {

        try {
            let controls: any = this.formSettings.controls;
            let toggleID: string;
            let accountLocation: string;
            let appspaceServerUrl: string;
            let isSignageInStandbyEnabled: string;
            let isSignageAsBackgroundEnabled: string;

            //When Main in unchecked
            toggleID = "appspace-enabled";
            accountLocation = "appspace-account-location";
            appspaceServerUrl = "appspace-server-url";
            isSignageInStandbyEnabled = "appspace-isSignageInStandbyEnabled";
            isSignageAsBackgroundEnabled = "appspace-isSignageAsBackgroundEnabled";

            let accountLocationValue: string = controls[accountLocation].value

            if (controls[accountLocation] && (accountLocationValue === "PrivateInstance")) {
                controls[appspaceServerUrl].model.visible = true;
            }
            else {
                controls[appspaceServerUrl].model.visible = false;
            }

            if (controls[toggleID].model.apply === false) {

                if (!controls[toggleID].model.inherited) controls[toggleID].setValue(false);

            }
            if (controls[toggleID].value === false) {
                (controls[accountLocation]) && (controls[accountLocation].model.apply = false);
                (controls[appspaceServerUrl]) && (controls[appspaceServerUrl].model.apply = false);
                (controls[isSignageInStandbyEnabled]) && (controls[isSignageInStandbyEnabled].model.apply = false);
                (controls[isSignageAsBackgroundEnabled]) && (controls[isSignageAsBackgroundEnabled].model.apply = false);
             }

            this.evalField(toggleID, accountLocation);
            this.evalField(toggleID, appspaceServerUrl);
            this.evalField(toggleID, isSignageInStandbyEnabled);
            this.evalField(toggleID, isSignageAsBackgroundEnabled);

           
        }
        catch (e) {
            console.log("Error-->checkAppspace()");
        }

    }

    //----------------------------------------------------------
    //checkVideoDisplay
    //----------------------------------------------------------
    protected checkVideoDisplay() {
                try {
            let controls: any = this.formSettings.controls;
            let baud: boolean = false;
            let ipId: boolean = false;
            let channel: boolean = false;
            let port: boolean = false;
            let ipAddress: boolean = false;
            let model: string;
            let control: string;

            //this.displayDriverID = "1D3A3D17-0F53-4f37-AF72-C5EEF9275477";
            
            if (controls["video-display-model"] && this.displayDrivers) {

                //1. Get Model name
                model = controls["video-display-model"].value;

                if (controls["video-display-driver-control"]) {

                    if (this.displayDrivers[model]) {


                        //2. Based on model, change contents of driver control
                        if (controls["video-display-driver-control"].model.options) {


                            //loop thru each options
                            let newOptions = [];
                            let driverModel: any = this.displayDrivers[model];
                            for (var property in driverModel) {
                                if (driverModel.hasOwnProperty(property)) {
                                    newOptions.push({
                                        label: property, value: property
                                    });
                                }
                            }

                            if (newOptions[0].value !== controls["video-display-driver-control"].model.options[0].value ||
                                newOptions.length !== controls["video-display-driver-control"].model.options.length) {

                                controls["video-display-driver-control"].model.options = newOptions;

                                if (!controls["video-display-driver-control"].model.inherited) {
                                    if (this.dirty) { //MM - Bug 128884 - Only force the first item if the form has changed, not on initial load
                                        controls["video-display-driver-control"].setValue(newOptions[0].value);
                                    }
                                }


                            }

                        }


                        //3. Get driver control
                        control = controls["video-display-driver-control"].value;


                        //4. Based on model and driver control... get matrix values
                        if (this.displayDrivers[model][control]) {

                            baud = this.displayDrivers[model][control].baud;
                            ipId = this.displayDrivers[model][control].ipId;
                            channel = this.displayDrivers[model][control].channel;
                            port = this.displayDrivers[model][control].port;
                            ipAddress = this.displayDrivers[model][control].ipAddress;
                            this.displayDriverID = this.displayDrivers[model][control].driverId;

                        }

                        //5. Based on matrix values... show/hide driver fields
                        (controls["video-display-driver-baud-rate"]) && (controls["video-display-driver-baud-rate"].model.visible = baud);
                        (controls["video-display-driver-ip-id"]) && (controls["video-display-driver-ip-id"].model.visible = ipId);

                        if (controls["video-display-driver-channel"]) {
                            controls["video-display-driver-channel"].model.visible = channel;
                            let control1: any = controls["video-display-driver-channel"];
                            if (channel) {
                                this.setCrestronValidation(control1);
                            }
                            else {
                                control1.clearValidators();
                            }
                        }
                        if (controls["video-display-driver-ip-address"]) {
                            controls["video-display-driver-ip-address"].model.visible = ipAddress;
                            let control2: any = controls["video-display-driver-ip-address"];
                            if (ipAddress) {
                                this.setCrestronValidation(control2);
                            }
                            else {
                                control2.clearValidators();
                            }
                        }
                        if (controls["video-display-driver-port"]) {
                            controls["video-display-driver-port"].model.visible = port;
                            let control3: any = controls["video-display-driver-port"];
                            if (port) {
                                this.setCrestronValidation(control3);
                            }
                            else {
                                control3.clearValidators();
                            }
                        }
                    }

                }

            }


        }
        catch (e) {
            console.log("Error-->checkVideoDisplay()");
        }

    }

    //----------------------------------------------------------
    //checkFusion
    //----------------------------------------------------------
    protected checkFusion() {

        try {
            let controls: any = this.formSettings.controls;
            let id: string;
            let toggleID: string;

            // let tlsID: string;//MM- Removed as per Brian
            let ipID: string;
            let roomNameID: string;



            toggleID = "fusion-enabled";
            if (controls[toggleID]) {


                //tlsID = "fusion-enable-tls";//MM- Removed as per Brian
                ipID = "fusion-ip-id";
                roomNameID = "fusion-room-name";


                if (controls[toggleID].model.apply === false) {
                    if (!controls[toggleID].model.inherited) controls[toggleID].setValue(false);
                }
                if (controls[toggleID].value === false) {
                    //controls[tlsID].model.apply = false;//MM- Removed as per Brian
                    controls[ipID].model.apply = false;
                    controls[roomNameID].model.apply = false;

                }
                else if (controls[toggleID].value === true) {
                    if (controls[ipID].model.value !== controls[ipID].value) {
                        controls[ipID].setValue(controls[ipID].model.value);
                    }
                }

                //this.evalField(toggleID, tlsID);//MM- Removed as per Brian
                this.evalField(toggleID, ipID);
                this.evalField(toggleID, roomNameID);




            }


            toggleID = "fusion-cloud-url-enabled";
            if (controls[toggleID]) {

                id = "fusion-cloud-url";

                if (controls[toggleID].model.apply === false) {
                    if (!controls[toggleID].model.inherited) controls[toggleID].setValue(false);
                }
                if (controls[toggleID].value === false) {
                    controls[id].model.apply = false;

                }

                this.evalField(toggleID, id);


            }
        }
        catch (e) {
            console.log("Error-->checkCustomLogo()");
        }

    }

    //----------------------------------------------------------
    //checkCustomBackgrounds
    //----------------------------------------------------------
    protected checkCustomBackgrounds() {

        try {
            let controls: any = this.formSettings.controls;
            let urlID: string;
            let toggleMainID: string;
            let toggleChildID: string;


            //When Main in unchecked
            toggleMainID = "enable-custom-backgrounds";
            if (controls[toggleMainID]) {
                if (controls[toggleMainID].model.apply === false) {
                    if (!controls[toggleMainID].model.inherited) controls[toggleMainID].setValue(false);
                }
            }


            if (controls[toggleMainID]) {
                for (var count = 1; count <= 15; count++) {


                    //MM - No more enabled fields...
                    // toggleChildID = "custom-background-url-" + count.toString() + "-enabled";
                    // this.evalField(toggleMainID, toggleChildID);

                    //Take care of child fields
                    urlID = "custom-background-url-" + count.toString();


                    //Hide the toggle child fields.. if necessary
                    if (controls[toggleMainID].value === true) {

                        //MM - No more enabled fields...
                        //controls[toggleChildID].model.visible = true;
                        //if (this.device) {
                        //    controls[toggleChildID].model.apply = true;
                        //    controls[toggleChildID].enable();
                        //}

                        controls[urlID].model.visible = true;

                    }
                    else {

                        //MM - No more enabled fields...
                        // if (!controls[toggleChildID].model.inherited) controls[toggleChildID].setValue(false);

                        //MM - No more enabled fields...
                        //controls[toggleChildID].model.visible = false;

                        controls[urlID].model.visible = false;


                    }


                    //When Toggle in unchecked
                    //MM - No more enabled fields...
                    //if (controls[toggleChildID].model.apply === false) {
                    //    if (!controls[toggleChildID].model.inherited) controls[toggleChildID].setValue(false);
                    //}


                    //Hide the URL child fields.. if necessary
                    //MM - No more enabled fields...
                    //if (controls[toggleChildID].value === false) {
                    if (controls[toggleMainID].value === false) {
                        controls[urlID].model.apply = false;
                    }

                    //MM - No more enabled fields...
                    //this.evalField(toggleChildID, urlID);
                    this.evalField(toggleMainID, urlID);


                }

            }


        }
        catch (e) {
            console.log("Error-->checkCallNotification()");
        }

    }

    //----------------------------------------------------------
    //checkCallNotification
    //----------------------------------------------------------
    protected checkCallNotification() {


        try {
            let controls: any = this.formSettings.controls;
            let id: string;
            let toggleID: string;



            toggleID = "enable-call-notification";
            if (controls[toggleID]) {

                id = "call-notification-timeout";

                if (controls[toggleID].model.apply === false) {
                    if (!controls[toggleID].model.inherited) controls[toggleID].setValue(false);
                }
                if (controls[toggleID].value === false) {
                    controls[id].model.apply = false;

                }

                this.evalField(toggleID, id);



            }

        }
        catch (e) {
            console.log("Error-->checkCallNotification()");
        }
    }

    //----------------------------------------------------------
    //checkCustomLogo
    //----------------------------------------------------------
    protected checkCustomLogo() {

        try {
            let controls: any = this.formSettings.controls;
            let id: string;
            let toggleID: string;



            toggleID = "enable-custom-logo-graphic";
            if (controls[toggleID]) {

                id = "custom-logo-graphic-url";
                this.evalField(toggleID, id);



            }
        }
        catch (e) {
            console.log("Error-->checkCustomLogo()");
        }

    }
    //----------------------------------------------------------
    //checkAirMedia
    //----------------------------------------------------------
    protected checkAirMedia() {

        try {
            let controls: any = this.formSettings.controls;
            let id: string;
            let toggleID: string;


            toggleID = "airmedia-login-code-mode";

            if (controls[toggleID]) {
                if (controls[toggleID].model.apply === false) {
                    if (!controls[toggleID].model.inherited) controls[toggleID].setValue("Disabled");
                }


                let bFlag: boolean = (controls[toggleID].value === "Fixed") ? true : false;
                id = "airmedia-login-code";
                this.evalFieldWithAValue(bFlag, id);
            }
        }
        catch (e) {
            console.log("Error-->checkAirMedia()");
        }

    }

    //----------------------------------------------------------
    //checkAirMediaConnectionInfo
    //----------------------------------------------------------
    protected checkAirMediaConnectionInfo() {

        try {
            let controls: any = this.formSettings.controls;
            let id: string;
            let toggleID: string;


            toggleID = "airmedia-connection-info-mode";

            if (controls[toggleID]) {
                if (controls[toggleID].model.apply === false) {
                    if (!controls[toggleID].model.inherited) controls[toggleID].setValue("Disabled");
                }


                let bFlag: boolean = (controls[toggleID].value === "Custom") ? true : false;
                id = "airmedia-custom-string";
                this.evalFieldWithAValue(bFlag, id);
            }
        }
        catch (e) {
            console.log("Error-->checkAirMediaConnectionInfo()");
        }

    }

    //----------------------------------------------------------
    //checkBluetooth
    //----------------------------------------------------------
    protected checkBluetooth() {

        try {
            let controls: any = this.formSettings.controls;
            let id: string;
            let toggleID: string;



            toggleID = "bluetooth-enabled";
            if (controls[toggleID]) {


                id = "friendly-bluetooth-name";
                this.evalField(toggleID, id);

                //MM - Removed as per Mike Troup 3/21/17
                //id = "bluetooth-enable-dial-hangup-buttons";
                //this.evalField(toggleID, id);


            }
        }
        catch (e) {
            console.log("Error-->checkBluetooth()");
        }

    }
    //----------------------------------------------------------
    //evalField
    //----------------------------------------------------------
    protected evalFieldWithAValue(toggleValue: boolean, id: string) {


        try {
            let controls: any = this.formSettings.controls;
            if (controls[id]) {

                //MM- For evaluating most fields.. when toggle is enabled, all member controls should enable.
                if (toggleValue) {
                    controls[id].model.locked = false;
                    if (this.device) {
                        if (controls[id].model.visible && !controls[id].model.inherited) {
                            this.setCrestronValidation(controls[id]);
                            controls[id].model.apply = true;
                            controls[id].enable();

                        }
                    }
                }
                else {

                    switch (controls[id].model.type) {

                        case DeviceControlType.InputSwitch:
                        case DeviceControlType.CheckBox:
                            if (!controls[id].model.inherited) controls[id].setValue(false);

                            break;

                        case DeviceControlType.ComboBox:
                        case DeviceControlType.RadioButton:
                            if (!controls[id].model.inherited) controls[id].setValue(controls[id].model.options[0]);

                            break;

                        case DeviceControlType.TextBox:
                        case DeviceControlType.Password:
                            if (!controls[id].model.inherited) controls[id].setValue("");

                            break;
                    }



                    controls[id].clearValidators();
                    controls[id].model.locked = true;
                    controls[id].model.apply = false;
                    controls[id].disable();

                }


            }
        }
        catch (e) {
            console.log("Error-->evalFieldWithAValue()");
        }

    }
    //----------------------------------------------------------
    //checkScheduling
    //----------------------------------------------------------
    protected checkScheduling() {

        try {
            let controls: any = this.formSettings.controls;
            let id: string;
            let toggleID: string;
            let childToggleID: string;


            toggleID = "enable-scheduling"
            childToggleID = "source";
            if (controls[toggleID]) {

                if (!controls[toggleID].model.apply) {
                    controls[toggleID].setValue(false);
                }

                if (controls[toggleID].value) {
                    controls[childToggleID].model.locked = false;
                    if (this.device) {

                        if (!controls[childToggleID].model.inherited) {
                            controls[childToggleID].model.apply = true;
                            controls[childToggleID].enable();
                        }
                    }
                }
                else {
                    controls[childToggleID].setValue(false);
                    controls[childToggleID].model.apply = false;
                    controls[childToggleID].model.locked = true;
                    controls[childToggleID].disable();
                }
            }

            toggleID = childToggleID;
            if (controls[toggleID]) {

                if (controls[toggleID].model.apply === false) {
                    if (!controls[toggleID].model.inherited) controls[toggleID].setValue("Fusion");
                }

                let bFlag: boolean = (controls[toggleID].value === "Exchange") ? true : false;


                id = "outlook-resource-address";
                this.evalFieldWithAValue(bFlag, id);

                id = "outlook-web-access-url";
                this.evalFieldWithAValue(bFlag, id);

                id = "outlook-domain-name";
                this.evalFieldWithAValue(bFlag, id);

                id = "outlook-user-email-address";
                this.evalFieldWithAValue(bFlag, id);

                id = "outlook-password";
                this.evalFieldWithAValue(bFlag, id);



            }


        }
        catch (e) {
            console.log("Error-->checkScheduling()");
        }
    }
    //----------------------------------------------------------
    //checkSIP
    //----------------------------------------------------------
    protected checkSIP() {

        try {
            let controls: any = this.formSettings.controls;
            let id: string;
            let toggleID: string;
            let toggleChildID: string;
            let nameID: string;
            let numberID: string;

            let usernameID: string;
            let realmID: string;
            let passwordID: string;
            let portID: string;

            let ipAddress: string;
            let proxyServer: string;
            let ethernetPort: string;
            let localExt: string;
            let transportType: string;
            let displayExtension: string;


            toggleID = "enable-sip";
            if (controls[toggleID]) {

                usernameID = "sip-server-username";
                realmID = "sip-server-realm";
                passwordID = "sip-server-password";
                portID = "sip-port";

                ipAddress = "sip-server-ip-address";
                proxyServer = "sip-proxy-server";
                ethernetPort = "assigned-sip-ethernet-port";
                localExt = "sip-local-extension";
                transportType = "sip-transport-type";
                displayExtension ="sip-display-extension";

                if (controls[toggleID].model.apply === false) {

                    if (!controls[toggleID].model.inherited) controls[toggleID].setValue(false);

                }
                if (controls[toggleID].value === false) {
                    (controls[usernameID]) && (controls[usernameID].model.apply = false);
                    (controls[realmID]) && (controls[realmID].model.apply = false);
                    (controls[passwordID]) && (controls[passwordID].model.apply = false);
                    (controls[portID]) && (controls[portID].model.apply = false);
                    (controls[ipAddress]) && (controls[ipAddress].model.apply = false);
                    (controls[proxyServer]) && (controls[proxyServer].model.apply = false);
                    (controls[ethernetPort]) && (controls[ethernetPort].model.apply = false);
                    (controls[localExt]) && (controls[localExt].model.apply = false);
                    (controls[displayExtension]) && (controls[displayExtension].model.apply = false);
                }

                this.evalField(toggleID, usernameID);
                this.evalField(toggleID, realmID);
                this.evalField(toggleID, passwordID);
                this.evalField(toggleID, portID);

                this.evalField(toggleID, ipAddress);
                this.evalField(toggleID, proxyServer);
                this.evalField(toggleID, ethernetPort);
                this.evalField(toggleID, localExt);
                this.evalField(toggleID, transportType);
                this.evalField(toggleID, displayExtension);

                //Make sure SIP Port is 5060 by default
                if (controls[toggleID].value === true) {
                    if (controls[portID] && (controls[portID].value === null || controls[portID].value.toString().trim() === "")) {
                        if (!controls[portID].model.inherited) controls[portID].setValue("5060");
                    }
                }



                for (var count = 1; count <= 4; count++) {

                    //Take care of all enabler fields
                    toggleChildID = "speedkey-" + count.toString() + "-enabled";


                    //Take care of child fields
                    nameID = "speedkey-" + count.toString() + "-name";
                    numberID = "speedkey-" + count.toString() + "-number";

                    //If the speedkey is not selected
                    if (controls[toggleChildID].model.apply === false) {
                        if (!controls[toggleChildID].model.inherited) controls[toggleChildID].setValue(false);
                    }
                    //If the speedkey is not enabled
                    if (controls[toggleChildID].value === false) {
                        controls[nameID].model.apply = false;
                        controls[numberID].model.apply = false;

                    }

                    this.evalField(toggleChildID, nameID);
                    this.evalField(toggleChildID, numberID);



                }


            }

        }
        catch (e) {
            console.log("Error-->checkSIP()");
        }

    }

    //----------------------------------------------------------
    //checkSIP
    //----------------------------------------------------------
    protected checkSFB() {
        let controls: any = this.formSettings.controls;
        let id: string;
        let toggleID: string;
        let toggleChildID: string;
        let nameID: string;
        let numberID: string;
        let typeID: string;

        let usernameID: string;
        let internaleServerName: string;
        let externalServerName: string;
        let proxyTypeID: string;
        let proxyUsernameID: string;
        let proxyPasswordID: string;
        let passwordID: string;
        let sipAddress: string;
        let displayExtension: string;

        toggleID = "sfb-enabled";
        //Main SFB settings
        if (controls[toggleID]) {

            usernameID = "sfb-username";
            passwordID = "sfb-password";
            internaleServerName = "sfb-internal-server-name";
            externalServerName = "sfb-external-server-name";

            sipAddress = "sfb-sip-address";
            proxyTypeID = "sfb-proxy-type";
            proxyUsernameID = "sfb-proxy-username";
            proxyPasswordID = "sfb-proxy-password";
            displayExtension = "sfb-display-extension";

            if (controls[toggleID].model.apply === false) {

                if (!controls[toggleID].model.inherited) controls[toggleID].setValue(false);

            }
            if (controls[toggleID].value === false) {
                (controls[usernameID]) && (controls[usernameID].model.apply = false);
                (controls[passwordID]) && (controls[passwordID].model.apply = false);
                (controls[sipAddress]) && (controls[sipAddress].model.apply = false);
                (controls[internaleServerName]) && (controls[internaleServerName].model.apply = false);
                (controls[externalServerName]) && (controls[externalServerName].model.apply = false);
                (controls[displayExtension]) && (controls[displayExtension].model.apply = false);
                (controls[proxyTypeID]) && (controls[proxyTypeID].model.apply = false);
                (controls[proxyUsernameID]) && (controls[proxyUsernameID].model.apply = false);
                (controls[proxyPasswordID]) && (controls[proxyPasswordID].model.apply = false);
            }

            this.evalField(toggleID, usernameID);
            this.evalField(toggleID, passwordID);
            this.evalField(toggleID, sipAddress);
            this.evalField(toggleID, internaleServerName);
            this.evalField(toggleID, externalServerName);
            this.evalField(toggleID, displayExtension);
            this.evalField(toggleID, proxyTypeID);

            if (controls[toggleID].value === true) {
                if (controls[proxyTypeID].value === "OtherCredentials") {
                    this.evalFieldWithAValue(true, proxyUsernameID);
                    this.evalFieldWithAValue(true, proxyPasswordID);
                }
                else {
                    this.evalFieldWithAValue(false, proxyUsernameID);
                    this.evalFieldWithAValue(false, proxyPasswordID);
                }
            }
            else {
                this.evalField(toggleID, proxyUsernameID);
                this.evalField(toggleID, proxyPasswordID);
            }



            //SFB Presets
            for (var count = 1; count <= 4; count++) {

                //Take care of all enabler fields
                toggleChildID = "sfb-preset-" + count.toString() + "-enabled";

                //Bug 137927 - If Top level SFB button is disable then disable all the Presets
                if (controls[toggleID].value === false) {
                    this.evalFieldWithAValue(false, toggleChildID);
                }
                else {
                    this.evalFieldWithAValue(true, toggleChildID);
                }

                //Take care of child fields
                nameID = "sfb-preset-" + count.toString() + "-name";
                numberID = "sfb-preset-" + count.toString() + "-number";
                typeID = "sfb-preset-" + count.toString() + "-type";
                //If the speedkey is not selected
                if (controls[toggleChildID].model.apply === false) {
                    if (!controls[toggleChildID].model.inherited) controls[toggleChildID].setValue(false);
                }
                //If the speedkey is not enabled
                if (controls[toggleChildID].value === false) {
                    controls[nameID].model.apply = false;
                    controls[numberID].model.apply = false;
                    controls[typeID].model.apply = false;


                }

                this.evalField(toggleChildID, nameID);
                this.evalField(toggleChildID, numberID);
                this.evalField(toggleChildID, typeID);


                if (controls[toggleChildID].value === true) {
                    if (this.isSfBTypeControl(typeID)) {
                        //MM Bug 138071 - Issue #2
                        this.sfbPresetTypeChangeEvent(typeID, controls[typeID].value);
                    }

                }



            }

        }


    }

    //----------------------------------------------------------
    //check AirMedia Connection Display
    //----------------------------------------------------------
    protected checkAirMediaConnectionDisplay() {
        let controls: any = this.formSettings.controls;
        let id: string;
        let toggleID: string;
        let toggleChildID: string;
        let nameID: string;
        let numberID: string;
        let typeID: string;

        let displayIPAdressID: string;
        let displayHostNameID: string;
        let displayDomainNameID: string;
        let displayCustomstringID: string;
        let displayCustomID: string;

        displayIPAdressID = "airmedia-display-ipaddress";
        displayHostNameID = "airmedia-display-hostname";
        displayDomainNameID = "airmedia-display-domainname";
        displayCustomstringID = "airmedia-display-custom-string";
        displayCustomID = "airmedia-custom-string";


        if (controls[displayHostNameID] && controls[displayDomainNameID]) {
            if (controls[displayHostNameID].model.apply === false) {
                if (!controls[displayHostNameID].model.inherited) controls[displayHostNameID].setValue(false);
            }
            if (controls[displayDomainNameID].model.apply === false) {
                if (!controls[displayDomainNameID].model.inherited) controls[displayDomainNameID].setValue(false);
            }
            if (controls[displayHostNameID].value === false) {
                (controls[displayDomainNameID]) && (controls[displayDomainNameID].model.apply = false);
                this.evalFieldWithAValue(false, displayDomainNameID);
            }
            else {
                this.evalFieldWithAValue(true, displayDomainNameID);
            }
        }

        if (controls[displayIPAdressID] && controls[displayHostNameID] && controls[displayDomainNameID]) {

            if (controls[displayIPAdressID].model.apply === false) {
                if (!controls[displayIPAdressID].model.inherited) controls[displayIPAdressID].setValue(false);
            }
            if (controls[displayDomainNameID].model.apply === false) {
                if (!controls[displayDomainNameID].model.inherited) controls[displayDomainNameID].setValue(false);
            }

            if (controls[displayHostNameID].model.apply === false) {
                if (!controls[displayHostNameID].model.inherited) controls[displayHostNameID].setValue(false);
            }

            if (controls[displayIPAdressID].value === true || controls[displayHostNameID].value === true || controls[displayDomainNameID].value === true) {
                (controls[displayCustomstringID]) && (controls[displayCustomstringID].model.apply = false);
                this.evalFieldWithAValue(false, displayCustomstringID);
            }
            else {
                this.evalFieldWithAValue(true, displayCustomstringID);
            }

        }

        if (controls[displayCustomstringID] && controls[displayCustomID]) {

            //if (controls[displayCustomID].model.apply === false) {
            //    if (!controls[displayCustomID].model.inherited) controls[displayCustomID].setValue(false);
            //}

            if (controls[displayCustomstringID].value === true) {
                (controls[displayCustomID]) && (controls[displayCustomID].model.apply = false);

                this.evalFieldWithAValue(false, displayIPAdressID);
                this.evalFieldWithAValue(false, displayHostNameID);
                //this.evalFieldWithAValue(false, displayDomainNameID);
            }
            else if (controls[displayCustomstringID].value === false) {
                this.evalFieldWithAValue(true, displayIPAdressID);
                this.evalFieldWithAValue(true, displayHostNameID);
                //this.evalFieldWithAValue(true, displayDomainNameID);

            }


          //  this.evalField(displayCustomstringID, displayCustomID);
            controls[displayCustomID].setValidators([Validators.maxLength(40)]);
            // this.setCrestronValidation(controls[displayCustomID]);

        }

    }

    //----------------------------------------------------------
    //checkZoom Room
    //----------------------------------------------------------
    protected checkZoomRoom() {
        let controls: any = this.formSettings.controls;
        let id: string;
        id = "zoomRoom-enabled";

        if (controls[id]) {

            if (this.zoomRoomInitValue !== controls[id].value) {
                if (controls[id].value === true) {

                    this.lblzoomRoomConfirmDialogMessage = this.translationService.translate("zoomRoom-confirm-dailog-enable-message");
                }
                else {
                    this.lblzoomRoomConfirmDialogMessage = this.translationService.translate("zoomRoom-confirm-dailog-disable-message");
                }

                this.zoomRoomConfirmDialog = true;
            }


        }

    }
    //----------------------------------------------------------
    //zoomRoomconfirmResponse
    //----------------------------------------------------------
    protected zoomRoomconfirmResponse(event): void {
        let controls: any = this.formSettings.controls;
        let id: string;
        id = "zoomRoom-enabled";

        if (event.response === false) {
            controls[id].setValue(this.zoomRoomInitValue);

        }

        this.zoomRoomConfirmDialog = false;
    }

    //----------------------------------------------------------
    //checkZoomRoomInit
    //----------------------------------------------------------
    protected checkZoomRoomInit() {
        let controls: any = this.formSettings.controls;
        let id: string;
        id = "zoomRoom-enabled";

        if (controls[id]) {
            if (controls[id].model.apply === false) {

                if (!controls[id].model.inherited) controls[id].setValue(false);

            }

        }

    }

    //----------------------------------------------------------
    //check3SeriesFusionCloudInit
    //----------------------------------------------------------
    protected check3SeriesFusionCloudInit() {
        try {
            let controls: any = this.formSettings.controls;
            let Urlid: string;
            let toggleID: string;



            toggleID = "s3-fusion-cloud-url-enabled";
            if (controls[toggleID]) {


                Urlid = "s3-fusion-cloud-url";

                if (controls[toggleID].model.apply === false) {
                    if (!controls[toggleID].model.inherited) controls[toggleID].setValue(false);
                }

                if (controls[toggleID].value === false) {
                    (controls[Urlid]) && (controls[Urlid].model.apply = false);
                }

                this.evalField(toggleID, Urlid);

            }
        }
        catch (e) {
          console.log("Error-->check3SeriesFusionCloudInit()");
        }


    }

    //----------------------------------------------------------
    //evalField
    //----------------------------------------------------------
    protected evalField(toggleID: string, id: string) {


        try {
            let controls: any = this.formSettings.controls;
            if (controls[toggleID] && controls[id]) {


                if (controls[toggleID].model.apply === false) {
                    if (!controls[toggleID].model.inherited) controls[toggleID].setValue(false);
                }

                //MM- For evaluating most fields.. when toggle is enabled, all member controls should enable.
                if (controls[toggleID].value === true) {

                    controls[id].model.locked = false;
                    if (this.device) {
                        if (controls[id].model.visible && !controls[id].model.inherited) {
                            this.setCrestronValidation(controls[id]);
                            controls[id].model.apply = true;
                            controls[id].enable();
                        }

                    }
                }
                else {

                    switch (controls[id].model.type) {

                        case DeviceControlType.InputSwitch:
                        case DeviceControlType.CheckBox:
                            if (!controls[id].model.inherited) controls[id].setValue(false);

                            break;

                        case DeviceControlType.ComboBox:
                        case DeviceControlType.RadioButton:
                            if (!controls[id].model.inherited) controls[id].setValue(controls[id].model.options[0]);

                            break;

                        case DeviceControlType.TextBox:
                        case DeviceControlType.Password:
                            if (!controls[id].model.inherited) controls[id].setValue("");

                            break;
                    }

                    controls[id].clearValidators();
                    controls[id].model.locked = true;
                    controls[id].model.apply = false;
                    controls[id].disable();

                }


            }
        }
        catch (e) {
            console.log("Error-->evalField()");
        }

    }



    //----------------------------------------------------------
    //evalDNS
    //----------------------------------------------------------
    protected evalDNS(id: string, toggleID: string) {


        try {
            let controls: any = this.formSettings.controls;

            //MM- For evaluating NIC fields, its reversed.. when toggle is ENABLED, all related controls should DISABLE.
            if (controls[toggleID] && controls[id]) {

                //if (controls[toggleID].value === true) {
                //    controls[id].model.locked = true;
                //    controls[id].model.apply = false;
                //    controls[id].disable();
                //}
                //else {
                //    controls[id].model.locked = false;
                //    if (this.device) {
                //        if (!controls[id].model.inherited) {
                //            controls[id].model.apply = true;
                //            controls[id].enable();
                //        }
                //    }

                //}

                //[staticAddress] vs [address]: If DHCP is enabled.. load the [address] field...
                let addressVal: string = this.getValueFromModel(controls[id].model, DevicePropertyType.GetValue);
                if (controls[id].value !== addressVal) {
                    if (!controls[id].model.inherited) controls[id].setValue(addressVal);
                }


            }


        }
        catch (e) {
            console.log("Error-->evalDNS()");
        }

    }

    //----------------------------------------------------------
    //evalNIC
    //----------------------------------------------------------
    protected evalNIC(id: string, toggleID: string) {


        try {
            let controls: any = this.formSettings.controls;

            //MM- For evaluating NIC fields, its reversed.. when toggle is ENABLED, all related controls should DISABLE.
            if (controls[toggleID] && controls[id]) {

                if (controls[toggleID].value === true) {
                    controls[id].model.locked = true;
                    controls[id].model.apply = false;
                    controls[id].disable();
                }
                else {
                    controls[id].model.locked = false;
                    if (this.device) {
                        if (!controls[id].model.inherited) {
                            controls[id].model.apply = true;
                            controls[id].enable();
                        }
                    }

                }

                //[staticAddress] vs [address]: If DHCP is enabled.. load the [address] field...
                let addressVal: string = this.getValueFromModel(controls[id].model, DevicePropertyType.GetValue);
                if (controls[id].value !== addressVal) {
                    if (!controls[id].model.inherited) controls[id].setValue(addressVal);
                }


            }


        }
        catch (e) {
            console.log("Error-->evalNIC()");
        }

    }
    //-----------------------------------------------
    // SfB Presets - IsSfBPresetType
    //-----------------------------------------------
    protected isSfBTypeControl(controlID: string) {
        if (controlID == "sfb-preset-1-type" || controlID == "sfb-preset-2-type" || controlID == "sfb-preset-3-type" || controlID == "sfb-preset-4-type") {
            return true;
        }

        return false;
    }



    //-----------------------------------------------
    // SfB PresetType - ChangeEvent
    //-----------------------------------------------
    protected sfbPresetTypeChangeEvent(controlID: string, value: string) {
        let targetControlId: string = "";
        let targetControl: any;
        let validationType: string;
        let controls: any = this.formSettings.controls;

        switch (controlID) {
            case "sfb-preset-1-type":
                targetControlId = "sfb-preset-1-number";
                break;

            case "sfb-preset-2-type":
                targetControlId = "sfb-preset-2-number";
                break;

            case "sfb-preset-3-type":
                targetControlId = "sfb-preset-3-number";
                break;

            case "sfb-preset-4-type":
                targetControlId = "sfb-preset-4-number";
                break;
        }


        if (controls[targetControlId]) {
            targetControl = controls[targetControlId];
            controls[targetControlId].clearValidators();
            //MM - Bug 139410 - This markAsDirty line is causing unchanged fields to be marked dirty. Must be verified with Bug 138071..
            //controls[targetControlId].markAsDirty();

            // let presetTitle: string;
            switch (value) {

                case "Email":

                    controls[targetControlId].setValidators([Validators.required, this.validationService.Email, Validators.maxLength(256)]);
                    // presetTitle = "sfb-preset-type-email";
                    break;

                case "Number":

                    controls[targetControlId].setValidators([Validators.required, this.validationService.Numeric, Validators.maxLength(64)]);
                    // presetTitle = "sfb-preset-type-number" ;
                    break;

                case "Url":

                    controls[targetControlId].setValidators([Validators.required, this.validationService.URL, Validators.maxLength(256)]);
                    // presetTitle = "sfb-preset-type-url";

                    break;
            }

            //controls[targetControlId].model.label = this.validationService.translate(presetTitle);

            controls[targetControlId].model.locked = true;
            controls[targetControlId].model.apply = true;

            controls[targetControlId].updateValueAndValidity();
        }
    }

    //-----------------------------------------------
    // SfB Type  - Change Event
    //-----------------------------------------------
    protected sfbProxyTypeChangeEvent(controlID: string, value: string) {

        let proxyUsernameControlId: string;
        let proxypasswordControlId: string;
        let targetControl: any;
        let validationType: string;
        let controls: any = this.formSettings.controls;
        proxyUsernameControlId = "sfb-proxy-username";
        proxypasswordControlId = "sfb-proxy-password";

        if (value === "OtherCredentials") {

            this.evalFieldWithAValue(true, proxyUsernameControlId);
            this.evalFieldWithAValue(true, proxypasswordControlId);


            controls[proxyUsernameControlId].setValidators([Validators.required, Validators.maxLength(256), this.validationService.UPN]);
            //this.setCrestronValidation(controls[proxyUsernameControlId]);

            controls[proxypasswordControlId].setValidators([Validators.required, Validators.maxLength(128)]);
            //this.setCrestronValidation(controls[proxypasswordControlId]);


            controls[proxyUsernameControlId].updateValueAndValidity();
            controls[proxypasswordControlId].updateValueAndValidity();

        }
        else {
            this.evalFieldWithAValue(false, proxyUsernameControlId);
            this.evalFieldWithAValue(false, proxypasswordControlId);

        }


    }

    //-----------------------------------------------
    // sfbPresetEnableDisable
    //-----------------------------------------------
    protected sfbPresetEnableDisable(controlID: string, value: string) {
        let controls: any = this.formSettings.controls;

        switch (controlID) {

            case "sfb-preset-1-enabled":


                controls["sfb-preset-1-number"].setValidators([Validators.required, this.validationService.Numeric, Validators.maxLength(64)]);
                // this.setCrestronValidation(controls["sfb-preset-1-number"]);
                controls["sfb-preset-1-number"].updateValueAndValidity();
                controls["sfb-preset-1-type"].markAsDirty();
                controls["sfb-preset-1-type"].setValue(controls["sfb-preset-1-type"].model.options[0].value);
                break;

            case "sfb-preset-2-enabled":
                controls["sfb-preset-2-number"].setValidators([Validators.required, this.validationService.Numeric, Validators.maxLength(64)]);
                // this.setCrestronValidation(controls["sfb-preset-2-number"]);
                controls["sfb-preset-2-number"].updateValueAndValidity();
                controls["sfb-preset-2-type"].markAsDirty();
                controls["sfb-preset-2-type"].setValue(controls["sfb-preset-2-type"].model.options[0].value);

                break;

            case "sfb-preset-3-enabled":
                controls["sfb-preset-3-number"].setValidators([Validators.required, this.validationService.Numeric, Validators.maxLength(64)]);
                // this.setCrestronValidation(controls["sfb-preset-3-number"]);
                controls["sfb-preset-3-number"].updateValueAndValidity();
                controls["sfb-preset-3-type"].markAsDirty();
                controls["sfb-preset-3-type"].setValue(controls["sfb-preset-3-type"].model.options[0].value);

                break;

            case "sfb-preset-4-enabled":
                controls["sfb-preset-4-number"].setValidators([Validators.required, this.validationService.Numeric, Validators.maxLength(64)]);
                //this.setCrestronValidation(controls["sfb-preset-4-number"]);
                controls["sfb-preset-4-number"].updateValueAndValidity();
                controls["sfb-preset-4-type"].markAsDirty();
                controls["sfb-preset-4-type"].setValue(controls["sfb-preset-4-type"].model.options[0].value);

                break;
        }
    }

    //SA added one common method for CFA
    protected modelTypesForCFA(): boolean {
        let flag: boolean = false;

        switch (this.modelType) {
            case "MERCURY":
                flag = true;
                break;
            case "AM-300":
                flag = true;
                break;
            case "AM-200":
                flag = true;
                break;

        }
        return flag;
    }
}







// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/shared/cui-device-settings/cui-device-settings.component.ts